export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Time: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export enum ActivityLogAccessEnum {
  Allowed = 'ALLOWED',
  Rejected = 'REJECTED'
}

export type ActivityLogEntry = {
  __typename?: 'ActivityLogEntry';
  access?: Maybe<ActivityLogAccessEnum>;
  context?: Maybe<Scalars['JSONObject']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['UUID']['output'];
  createdByType: ActorType;
  createdByUser?: Maybe<User>;
  department?: Maybe<Department>;
  entityName?: Maybe<Scalars['String']['output']>;
  entityUuid?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  institution?: Maybe<Institution>;
  role?: Maybe<Role>;
  type: ActivityLogTypeEnum;
  user?: Maybe<User>;
};

export enum ActivityLogTypeEnum {
  ApprovalApproved = 'APPROVAL_APPROVED',
  ApprovalRejected = 'APPROVAL_REJECTED',
  AuthFail = 'AUTH_FAIL',
  AuthSuccess = 'AUTH_SUCCESS',
  DeviceCreated = 'DEVICE_CREATED',
  DeviceEdited = 'DEVICE_EDITED',
  PermissionGranted = 'PERMISSION_GRANTED',
  PermissionRevoke = 'PERMISSION_REVOKE',
  SequenceCreated = 'SEQUENCE_CREATED',
  SequenceDeleted = 'SEQUENCE_DELETED',
  SequenceEdited = 'SEQUENCE_EDITED',
  SequenceFinish = 'SEQUENCE_FINISH',
  SequenceScheduled = 'SEQUENCE_SCHEDULED',
  SequenceStart = 'SEQUENCE_START',
  SequenceStop = 'SEQUENCE_STOP',
  UserAdd = 'USER_ADD',
  UserDelete = 'USER_DELETE',
  UserDisabled = 'USER_DISABLED',
  UserEdit = 'USER_EDIT',
  UserEnabled = 'USER_ENABLED',
  UserViewActivityLog = 'USER_VIEW_ACTIVITY_LOG'
}

export enum ActorType {
  Customer = 'CUSTOMER',
  Employee = 'EMPLOYEE',
  Service = 'SERVICE'
}

export type Acuity = {
  comment?: InputMaybe<Scalars['String']['input']>;
  patientUuid?: InputMaybe<Scalars['UUID']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  userUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type AcuityType = {
  __typename?: 'AcuityType';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type AddLearningObjectData = {
  learningObjectUuid: Scalars['UUID']['input'];
};

export type AddMlSurveyInput = {
  departmentId: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  endsAt: Scalars['DateTime']['input'];
  institutionId: Scalars['UUID']['input'];
  language: MlSurveyLanguagesEnum;
  name: Scalars['String']['input'];
  startsAt: Scalars['DateTime']['input'];
  studyId: Scalars['UUID']['input'];
  type: MlSurveyTypeEnum;
};

export type AddMlSurveyResponse = {
  __typename?: 'AddMLSurveyResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type AddPatientInput = {
  acuity?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  admissionDate?: InputMaybe<Scalars['Date']['input']>;
  allergy?: InputMaybe<Array<InputMaybe<AllergyInput>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  conditionCode?: InputMaybe<Scalars['Int']['input']>;
  conditionName?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  departmentUuid: Scalars['UUID']['input'];
  dischargeDate?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<PatientGender>;
  height?: InputMaybe<Scalars['Int']['input']>;
  house?: InputMaybe<Scalars['String']['input']>;
  identification?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  medication?: InputMaybe<Array<InputMaybe<MedicationInput>>>;
  name: Scalars['String']['input'];
  nurseUuid?: InputMaybe<Scalars['UUID']['input']>;
  patientType?: InputMaybe<PatientTypeEnum>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primaryDiagnosis?: InputMaybe<Scalars['String']['input']>;
  secondaryDiagnosis?: InputMaybe<Scalars['String']['input']>;
  shiftUuid?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AddPatientProcedureInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientUuid: Scalars['UUID']['input'];
  procedureUuid: Scalars['UUID']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid: Scalars['UUID']['input'];
};

export type AddPatientProcedureResponse = {
  __typename?: 'AddPatientProcedureResponse';
  end?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  procedureUuid?: Maybe<Scalars['UUID']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type AddPatientResponse = {
  __typename?: 'AddPatientResponse';
  address?: Maybe<Scalars['String']['output']>;
  admissionDate?: Maybe<Scalars['Date']['output']>;
  allergy?: Maybe<Array<Maybe<AllergyType>>>;
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<Scalars['UUID']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  deletedBy?: Maybe<Scalars['UUID']['output']>;
  departmentUuid?: Maybe<Scalars['UUID']['output']>;
  dischargeDate?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<PatientGender>;
  house?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  identification?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  medication?: Maybe<Array<Maybe<MedicationType>>>;
  name?: Maybe<Scalars['String']['output']>;
  nurseUuid?: Maybe<Scalars['UUID']['output']>;
  patientType?: Maybe<PatientTypeEnum>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primaryDiagnosis?: Maybe<Scalars['String']['output']>;
  secondaryDiagnosis?: Maybe<Scalars['String']['output']>;
  shiftUuid?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updateAt?: Maybe<Scalars['Date']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<Scalars['UUID']['output']>;
};

export type AddPatientVisitInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['UUID']['input'];
  start: Scalars['DateTime']['input'];
  status?: InputMaybe<VisitStatusEnum>;
  userId: Scalars['UUID']['input'];
};

export type AddPatientVisitResponse = {
  __typename?: 'AddPatientVisitResponse';
  end?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<VisitStatusEnum>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type AddProcedureStepExecutionInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  parentStepUuid?: InputMaybe<Scalars['UUID']['input']>;
  procedureExecutionUuid: Scalars['UUID']['input'];
  procedureStepUuid: Scalars['UUID']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<ProcedureStepExecutionState>;
  stepExitUuid?: InputMaybe<Scalars['UUID']['input']>;
  type: ProcedureStepExecutionType;
};

export type AddProcedureStepExecutionResponse = {
  __typename?: 'AddProcedureStepExecutionResponse';
  duration?: Maybe<Scalars['Int']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  parentStepUuid?: Maybe<Scalars['UUID']['output']>;
  procedureExecutionUuid?: Maybe<Scalars['UUID']['output']>;
  procedureStepUuid?: Maybe<Scalars['UUID']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<ProcedureStepExecutionState>;
  stepExitUuid?: Maybe<Scalars['UUID']['output']>;
  type: ProcedureStepExecutionType;
};

export type AgeExperienceStats = {
  __typename?: 'AgeExperienceStats';
  femaleCount?: Maybe<Scalars['Int']['output']>;
  maleCount?: Maybe<Scalars['Int']['output']>;
  monthOfBirth?: Maybe<Scalars['String']['output']>;
};

export type AgeStats = {
  __typename?: 'AgeStats';
  averageAge?: Maybe<Scalars['Float']['output']>;
  monthOfBirth?: Maybe<Scalars['String']['output']>;
};

export type AllergyInput = {
  allergy: Scalars['String']['input'];
  allergyType?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
};

export type AllergyType = {
  __typename?: 'AllergyType';
  allergy?: Maybe<Scalars['String']['output']>;
  allergyType?: Maybe<Scalars['String']['output']>;
  reaction?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
};

export type AnswerResult = {
  __typename?: 'AnswerResult';
  answer?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AnswerResultInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum ApprovalActionType {
  DisableUser = 'DISABLE_USER',
  EnableUser = 'ENABLE_USER',
  ExportArrivalHistory = 'EXPORT_ARRIVAL_HISTORY',
  ExportLocationHistory = 'EXPORT_LOCATION_HISTORY',
  ExportStopHistory = 'EXPORT_STOP_HISTORY',
  ExportVisits = 'EXPORT_VISITS',
  PermissionGrant = 'PERMISSION_GRANT',
  PermissionRevoke = 'PERMISSION_REVOKE'
}

export type ApprovalRequest = {
  __typename?: 'ApprovalRequest';
  actionType: ApprovalActionType;
  approvedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  institution?: Maybe<Institution>;
  payload: Scalars['JSONObject']['output'];
  rejectedBy?: Maybe<User>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requestedBy: User;
  status: ApprovalStatus;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ApprovalRequestFilter {
  Active = 'ACTIVE',
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ApprovalRequestsInput = {
  filter?: InputMaybe<ApprovalRequestFilter>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type ApprovalRequestsResponse = {
  __typename?: 'ApprovalRequestsResponse';
  items: Array<ApprovalRequest>;
  pager?: Maybe<PagerResponse>;
};

export enum ApprovalStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type AverageDurationStats = {
  __typename?: 'AverageDurationStats';
  averageDuration?: Maybe<Scalars['Float']['output']>;
  month?: Maybe<Scalars['String']['output']>;
};

export type AverageTimeSpentOnProcedureResponseData = {
  __typename?: 'AverageTimeSpentOnProcedureResponseData';
  dataset?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  groupProcedureId?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  procedureId?: Maybe<Scalars['UUID']['output']>;
};

export type CbiChartData = {
  __typename?: 'CBIChartData';
  BURNOUT?: Maybe<Scalars['Float']['output']>;
  PATIENT_BURNOUT?: Maybe<Scalars['Float']['output']>;
  PERSONAL_BURNOUT?: Maybe<Scalars['Float']['output']>;
  WORK_BURNOUT?: Maybe<Scalars['Float']['output']>;
};

export type Category = {
  __typename?: 'Category';
  categoryType?: Maybe<CategoryType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  institution?: Maybe<Institution>;
  mlFeatureSubtype?: Maybe<MlFeatureSubtypeEnum>;
  mlFeatureType?: Maybe<MlFeatureTypeEnum>;
  name: Scalars['String']['output'];
  surveyUuid?: Maybe<Scalars['UUID']['output']>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export enum CategoryType {
  Device = 'DEVICE',
  Procedure = 'PROCEDURE',
  Question = 'QUESTION'
}

export type ChartDataCategoryResult = {
  __typename?: 'ChartDataCategoryResult';
  avg: Array<Scalars['Float']['output']>;
  categoryId: Scalars['ID']['output'];
  categoryName: Scalars['String']['output'];
  sum: Array<Scalars['Float']['output']>;
};

export type ChecklistAnswer = {
  __typename?: 'ChecklistAnswer';
  checklistUuid?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  results?: Maybe<Array<Maybe<AnswerResult>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
  visitUuid?: Maybe<Scalars['UUID']['output']>;
};

export type ChecklistPreset = {
  __typename?: 'ChecklistPreset';
  author?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  departmentUuid?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updateByType?: Maybe<ActorType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['UUID']['output']>;
};

export type ChecklistQuestion = {
  __typename?: 'ChecklistQuestion';
  checklistUuid?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updateByType?: Maybe<ActorType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['UUID']['output']>;
};

/** URL для редіректу в Stripe Checkout */
export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  url: Scalars['String']['output'];
};

export type ChoiceQuestion = {
  __typename?: 'ChoiceQuestion';
  answers?: Maybe<Array<Maybe<ScaleAnswer>>>;
  question?: Maybe<Scalars['String']['output']>;
  selectedAnswer?: Maybe<Scalars['String']['output']>;
};

export type CognitionQuestion = {
  __typename?: 'CognitionQuestion';
  cognitionType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CommentType = {
  __typename?: 'CommentType';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ConsentInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  patientUuid?: InputMaybe<Scalars['UUID']['input']>;
  signer?: InputMaybe<Signer>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type ConsentResponse = {
  __typename?: 'ConsentResponse';
  date?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  signer?: Maybe<Signer>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type CreateAcuityInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  patientUuid: Scalars['UUID']['input'];
  score: Scalars['Int']['input'];
  userUuid: Scalars['UUID']['input'];
};

export type CreateAcuityResponse = {
  __typename?: 'CreateAcuityResponse';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type CreateBillingPortalInput = {
  customerId: Scalars['String']['input'];
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBillingPortalPayload = {
  __typename?: 'CreateBillingPortalPayload';
  url: Scalars['String']['output'];
};

export type CreateCategoryInput = {
  categoryType: CategoryType;
  description?: InputMaybe<Scalars['String']['input']>;
  institutionId: Scalars['UUID']['input'];
  mlFeatureSubtype?: InputMaybe<MlFeatureSubtypeEnum>;
  name: Scalars['String']['input'];
  surveyUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateCategoryResponse = {
  __typename?: 'CreateCategoryResponse';
  category?: Maybe<Category>;
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateChecklistAnswerInput = {
  checklistUuid: Scalars['UUID']['input'];
  results?: InputMaybe<Array<InputMaybe<AnswerResultInput>>>;
  userUuid: Scalars['UUID']['input'];
  visitUuid: Scalars['UUID']['input'];
};

export type CreateChecklistPresetInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  departmentUuid: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type CreateChecklistQuestionInput = {
  checklistUuid: Scalars['UUID']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Параметри для створення Checkout-сесії */
export type CreateCheckoutInput = {
  customerId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type CreateDepartmentInput = {
  institutionId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type CreateDepartmentResponse = {
  __typename?: 'CreateDepartmentResponse';
  code?: Maybe<Scalars['String']['output']>;
  department: Department;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type CreateDeviceCommentInput = {
  comment: Scalars['String']['input'];
  deviceUuid: Scalars['UUID']['input'];
};

export type CreateDeviceCommentResponse = {
  __typename?: 'CreateDeviceCommentResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateDeviceInput = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  departmentId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['UUID']['input'];
  institutionId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  udi: Scalars['String']['input'];
};

export type CreateDeviceProcedureExecutionInput = {
  date: Scalars['Date']['input'];
  deviceUuid: Scalars['UUID']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  groupProcedureUuid: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeviceProcedureExecutionStatusEnum>;
  userUuid: Scalars['UUID']['input'];
};

export type CreateDeviceProcedureExecutionResponse = {
  __typename?: 'CreateDeviceProcedureExecutionResponse';
  procedureExecution?: Maybe<DeviceProcedureExecution>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateDeviceResponse = {
  __typename?: 'CreateDeviceResponse';
  device: Device;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type CreateGroupInput = {
  addLearningObject?: InputMaybe<Array<InputMaybe<AddLearningObjectData>>>;
  auditFrequency?: InputMaybe<Scalars['Int']['input']>;
  createGroupProcedure?: InputMaybe<Array<InputMaybe<CreateGroupProcedureInputData>>>;
  createLearningObject?: InputMaybe<Array<InputMaybe<CreateGroupLearningObjectInput>>>;
  departmentId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  institutionId: Scalars['UUID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  lifeCycleNum: Scalars['Int']['input'];
  lifeCycleTime: Scalars['String']['input'];
  name: Scalars['String']['input'];
  procedures?: InputMaybe<Scalars['UUID']['input']>;
  userManuals?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateGroupLearningObjectInput = {
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateGroupProcedureInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  frequencyNum: Scalars['Int']['input'];
  frequencyPeriod: FrequencyPeriodEnum;
  groupUuid: Scalars['UUID']['input'];
  institutionId?: InputMaybe<Scalars['UUID']['input']>;
  isAudit?: InputMaybe<Scalars['Boolean']['input']>;
  procedureUuid: Scalars['UUID']['input'];
};

export type CreateGroupProcedureInputData = {
  frequencyNum?: InputMaybe<Scalars['Int']['input']>;
  frequencyPeriod?: InputMaybe<FrequencyPeriodEnum>;
  isAudit: Scalars['Boolean']['input'];
  procedureUuid: Scalars['UUID']['input'];
};

export type CreateGroupProcedureResponse = {
  __typename?: 'CreateGroupProcedureResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateGroupResponse = {
  __typename?: 'CreateGroupResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateInstitutionInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  cvi?: InputMaybe<Scalars['JSONObject']['input']>;
  house?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  stopDetectionDuration?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInstitutionResponse = {
  __typename?: 'CreateInstitutionResponse';
  code?: Maybe<Scalars['String']['output']>;
  institution?: Maybe<Institution>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateInstitutionWithAdminAndDepartmentInput = {
  adminEmail: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  departmentName?: InputMaybe<Scalars['String']['input']>;
  house?: InputMaybe<Scalars['String']['input']>;
  institutionName: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInstitutionWithAdminAndDepartmentPayload = {
  __typename?: 'CreateInstitutionWithAdminAndDepartmentPayload';
  department?: Maybe<Department>;
  institution?: Maybe<Institution>;
  invite?: Maybe<InviteStub>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type CreateLearningObjectInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['UUID']['input'];
  institutionId: Scalars['UUID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permission?: InputMaybe<LearningObjectPermission>;
};

export type CreateLearningObjectResponse = {
  __typename?: 'CreateLearningObjectResponse';
  code?: Maybe<Scalars['String']['output']>;
  learningObject: LearningObject;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type CreateProcedureFeedbackAnswerInput = {
  answer: Array<InputMaybe<ProcedureFeedbackAnswer>>;
  key: Scalars['String']['input'];
  procedureFeedbackQuestionUuid: Scalars['UUID']['input'];
};

export type CreateProcedureInput = {
  categoryId: Scalars['UUID']['input'];
  checklist?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departmentId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  institutionId: Scalars['UUID']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<ProcedureStatus>;
  steps?: InputMaybe<Array<InputMaybe<ProcedureStepInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  writeKeyId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProcedureResponse = {
  __typename?: 'CreateProcedureResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  procedure: Procedure;
  status: Scalars['Boolean']['output'];
};

export type CreateQuestionInput = {
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  details?: InputMaybe<Scalars['JSONObject']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  surveyId: Scalars['UUID']['input'];
  type?: InputMaybe<QuestionType>;
};

export type CreateQuestionResponse = {
  __typename?: 'CreateQuestionResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Question>;
  status: Scalars['Boolean']['output'];
};

export type CreateStudyInput = {
  departmentId: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  institutionId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  permission?: InputMaybe<StudyPermission>;
};

export type CreateStudyResponse = {
  __typename?: 'CreateStudyResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  study: Study;
};

export type CreateSurveyInput = {
  description: Scalars['String']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  gate?: InputMaybe<Scalars['JSONObject']['input']>;
  hasGate: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  parentSurveyId?: InputMaybe<Scalars['UUID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  studyId: Scalars['UUID']['input'];
};

export type CreateSurveyResponse = {
  __typename?: 'CreateSurveyResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  survey: Survey;
};

export type CreateSurveyResultInput = {
  answers?: InputMaybe<Array<InputMaybe<SurveyResultAnswer>>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  surveyId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type CreateSurveyResultResponse = {
  __typename?: 'CreateSurveyResultResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  surveyResult?: Maybe<SurveyResult>;
};

export type CreateVisitChecklistInput = {
  anamnesis: Scalars['String']['input'];
  applied_medicinal_treatment: Scalars['String']['input'];
  applied_treatment: Scalars['String']['input'];
  blood_pressure_diastolic: Scalars['Int']['input'];
  blood_pressure_systolic: Scalars['Int']['input'];
  complaint_data: Scalars['String']['input'];
  condition_assessment: Scalars['String']['input'];
  consultation_plans: Scalars['String']['input'];
  diagnoses: Scalars['String']['input'];
  height: Scalars['Float']['input'];
  instrumental_tests: Scalars['String']['input'];
  laboratory_tests: Scalars['String']['input'];
  patient_status: Scalars['String']['input'];
  pulse: Scalars['Int']['input'];
  questions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  recommendations: Scalars['String']['input'];
  specialist: Scalars['String']['input'];
  visit_uuid: Scalars['UUID']['input'];
  weight: Scalars['Float']['input'];
};

export type CreateVisitTypeInput = {
  departmentUuid?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export enum CreatedByType {
  Customer = 'CUSTOMER',
  Employee = 'EMPLOYEE',
  Service = 'SERVICE',
  StripeHook = 'STRIPE_HOOK'
}

export type CurrentUserResponse = {
  __typename?: 'CurrentUserResponse';
  activeSub?: Maybe<Scalars['Boolean']['output']>;
  profile?: Maybe<User>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
};

export type DateRangeInput = {
  dateTimeFrom: Scalars['DateTime']['input'];
  dateTimeTo: Scalars['DateTime']['input'];
};

export type DeleteAcuityInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteAcuityResponse = {
  __typename?: 'DeleteAcuityResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteCategoryInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteCategoryResponse = {
  __typename?: 'DeleteCategoryResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteDepartmentInput = {
  departmentToDeleteUuid: Scalars['UUID']['input'];
  departmentToMoveUuid: Scalars['UUID']['input'];
};

export type DeleteDepartmentResponse = {
  __typename?: 'DeleteDepartmentResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteDeviceInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteDeviceProcedureExecutionInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteDeviceProcedureExecutionResponse = {
  __typename?: 'DeleteDeviceProcedureExecutionResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteDeviceResponse = {
  __typename?: 'DeleteDeviceResponse';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type DeleteGroupInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteGroupResponse = {
  __typename?: 'DeleteGroupResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteLearningObjectInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteLearningObjectResponse = {
  __typename?: 'DeleteLearningObjectResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type DeletePatientInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeletePatientProcedureInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeletePatientProcedureResponse = {
  __typename?: 'DeletePatientProcedureResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeletePatientResponse = {
  __typename?: 'DeletePatientResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeletePatientVisitInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeletePatientVisitResponse = {
  __typename?: 'DeletePatientVisitResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteProcedureInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteProcedureResponse = {
  __typename?: 'DeleteProcedureResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type DeleteProcedureStepExecutionInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteProcedureStepExecutionResponse = {
  __typename?: 'DeleteProcedureStepExecutionResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteQuestionCategoryInput = {
  id: Scalars['UUID']['input'];
  targetCategoryUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeleteQuestionCategoryResponse = {
  __typename?: 'DeleteQuestionCategoryResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteQuestionInput = {
  id: Scalars['UUID']['input'];
  surveyId: Scalars['UUID']['input'];
};

export type DeleteQuestionResponse = {
  __typename?: 'DeleteQuestionResponse';
  status: Scalars['Boolean']['output'];
};

export type DeleteStudyInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteStudyResponse = {
  __typename?: 'DeleteStudyResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type DeleteSurveyInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteSurveyResponse = {
  __typename?: 'DeleteSurveyResponse';
  status: Scalars['Boolean']['output'];
};

export type DeleteUsersInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteUsersResponse = {
  __typename?: 'DeleteUsersResponse';
  status: Scalars['String']['output'];
};

export type Department = {
  __typename?: 'Department';
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  id: Scalars['UUID']['output'];
  institution?: Maybe<Institution>;
  name?: Maybe<Scalars['String']['output']>;
  procedures?: Maybe<Array<Maybe<Procedure>>>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type Device = {
  __typename?: 'Device';
  author?: Maybe<User>;
  comment?: Maybe<Array<Maybe<DeviceComment>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  department?: Maybe<Department>;
  departmentUuid?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  groupUuid?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  lifeCycleEnd?: Maybe<Scalars['Date']['output']>;
  lifeCycleStart?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  nextAuditDate?: Maybe<Scalars['Date']['output']>;
  procedureExecution?: Maybe<Array<Maybe<DeviceProcedureExecution>>>;
  udi?: Maybe<Scalars['String']['output']>;
  updateAt?: Maybe<Scalars['Date']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export type DeviceComment = {
  __typename?: 'DeviceComment';
  comment?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['Date']['output']>;
  deviceUuid?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  userAvatar?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type DeviceProcedure = {
  __typename?: 'DeviceProcedure';
  author?: Maybe<User>;
  category?: Maybe<Category>;
  checklist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code?: Maybe<Scalars['UUID']['output']>;
  comments?: Maybe<Array<Maybe<CommentType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  departments?: Maybe<Array<Maybe<Department>>>;
  description?: Maybe<Scalars['String']['output']>;
  deviceProcedureUuid?: Maybe<Scalars['UUID']['output']>;
  deviceUuid?: Maybe<Scalars['UUID']['output']>;
  frequencyNum?: Maybe<Scalars['Int']['output']>;
  frequencyPeriod?: Maybe<FrequencyPeriodEnum>;
  id?: Maybe<Scalars['UUID']['output']>;
  isAudit?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextAuditDate?: Maybe<Scalars['Date']['output']>;
  patient?: Maybe<Array<Maybe<Patient>>>;
  procedureExecution?: Maybe<Array<Maybe<DeviceProcedureExecution>>>;
  status?: Maybe<ProcedureStatus>;
  steps?: Maybe<Array<Maybe<ProcedureStep>>>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export type DeviceProcedureExecution = {
  __typename?: 'DeviceProcedureExecution';
  date?: Maybe<Scalars['Date']['output']>;
  device?: Maybe<Device>;
  deviceUuid?: Maybe<Scalars['UUID']['output']>;
  end?: Maybe<Scalars['DateTime']['output']>;
  groupProcedure?: Maybe<GroupProcedure>;
  groupProcedureUuid?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isAudit?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<DeviceProcedureExecutionStatusEnum>;
  stepsExecution?: Maybe<Array<Maybe<ProcedureStepExecutionItem>>>;
  user?: Maybe<User>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export enum DeviceProcedureExecutionStatusEnum {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Started = 'STARTED',
  Stopped = 'STOPPED',
  Successful = 'SUCCESSFUL',
  Successfull = 'SUCCESSFULL'
}

export enum DeviceProcedureTypeEnum {
  Audit = 'AUDIT'
}

export type DeviceReportTotalItem = {
  __typename?: 'DeviceReportTotalItem';
  group?: Maybe<Group>;
  numberOfProcedures?: Maybe<NumberOfProceduresType>;
};

export type DisableUsersInput = {
  approvalId?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<Scalars['String']['input']>;
};

export type DisableUsersResponse = {
  __typename?: 'DisableUsersResponse';
  approvalRequest?: Maybe<ApprovalRequest>;
  status: Scalars['String']['output'];
};

export type EnableUsersInput = {
  approvalId?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<Scalars['String']['input']>;
};

export type EnableUsersResponse = {
  __typename?: 'EnableUsersResponse';
  approvalRequest?: Maybe<ApprovalRequest>;
  status: Scalars['String']['output'];
};

export type EndShiftInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['UUID']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EndShiftResponse = {
  __typename?: 'EndShiftResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type FreeTextQuestion = {
  __typename?: 'FreeTextQuestion';
  answer?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export enum FrequencyPeriodEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GetAcuityInput = {
  id: Scalars['UUID']['input'];
};

export type GetAcuityResponse = {
  __typename?: 'GetAcuityResponse';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type GetAverageNurseAgeChartInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  institutionId: Scalars['UUID']['input'];
};

export type GetAverageNurseAgeChartResponse = {
  __typename?: 'GetAverageNurseAgeChartResponse';
  data?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  dates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
};

export type GetAveragePatientAcuityDataInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId: Scalars['UUID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetAveragePatientAcuityDataResponse = {
  __typename?: 'GetAveragePatientAcuityDataResponse';
  averageNrOfPatients?: Maybe<Scalars['Float']['output']>;
  averageNrOfPatientsVsPreviousMonth?: Maybe<Scalars['Float']['output']>;
  averageShiftAcuity?: Maybe<Scalars['Float']['output']>;
  averageShiftAcuityVsPreviousMonth?: Maybe<Scalars['Float']['output']>;
};

export type GetAverageShiftDataInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId: Scalars['UUID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetAverageShiftDataResponse = {
  __typename?: 'GetAverageShiftDataResponse';
  averageShiftDuration?: Maybe<Scalars['Float']['output']>;
  averageShiftIntensity?: Maybe<Scalars['Float']['output']>;
  durationVsPreviousMonth?: Maybe<Scalars['Float']['output']>;
  intensityShiftVsPreviousWeek?: Maybe<Scalars['Float']['output']>;
};

export type GetAverageTimeSpentOnProcedureInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  groupId: Scalars['UUID']['input'];
  groupProcedureId?: InputMaybe<Scalars['UUID']['input']>;
  institutionId?: InputMaybe<Scalars['UUID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetAverageTimeSpentOnProcedureResponse = {
  __typename?: 'GetAverageTimeSpentOnProcedureResponse';
  data?: Maybe<Array<Maybe<AverageTimeSpentOnProcedureResponseData>>>;
  dates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
};

export type GetAverageTirednessInput = {
  departmentId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetAverageTirednessResponse = {
  __typename?: 'GetAverageTirednessResponse';
  tirednessAverage?: Maybe<Scalars['Float']['output']>;
  vsPreviousMonth?: Maybe<Scalars['Float']['output']>;
};

export type GetCategoriesInput = {
  categoryType: CategoryType;
  id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  institutionId: Scalars['UUID']['input'];
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<SearchInput>;
};

export type GetCategoriesResponse = {
  __typename?: 'GetCategoriesResponse';
  items?: Maybe<Array<Maybe<Category>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetChecklistAnswerByVisitIdInput = {
  visitUuid: Scalars['UUID']['input'];
};

export type GetChecklistAnswerInput = {
  uuid: Scalars['UUID']['input'];
};

export type GetChecklistPresetInput = {
  uuid: Scalars['UUID']['input'];
};

export type GetChecklistPresetsByDepartmentIdInput = {
  departmentUuid: Scalars['UUID']['input'];
};

export type GetChecklistQuestionsInput = {
  uuid: Scalars['UUID']['input'];
};

export type GetCurrentUserInput = {
  signUpToken?: InputMaybe<Scalars['String']['input']>;
};

export type GetDepartmentsInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  institutionId: Array<Scalars['UUID']['input']>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetDepartmentsResponse = {
  __typename?: 'GetDepartmentsResponse';
  items?: Maybe<Array<Maybe<Department>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetDeviceChartsInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  institutionId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetDeviceChartsResponse = {
  __typename?: 'GetDeviceChartsResponse';
  amountAuditNormal?: Maybe<Scalars['Int']['output']>;
  amountAuditPast?: Maybe<Scalars['Int']['output']>;
  amountAuditSoon?: Maybe<Scalars['Int']['output']>;
  amountEnded?: Maybe<Scalars['Int']['output']>;
  amountEnding?: Maybe<Scalars['Int']['output']>;
  amountNormal?: Maybe<Scalars['Int']['output']>;
};

export type GetDeviceInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  udi?: InputMaybe<Scalars['String']['input']>;
};

export type GetDeviceReportData = {
  __typename?: 'GetDeviceReportData';
  device?: Maybe<Device>;
  deviceProcedureExecution?: Maybe<DeviceProcedureExecution>;
  procedure?: Maybe<Procedure>;
};

export type GetDeviceReportInput = {
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  groupId: Scalars['UUID']['input'];
  pager?: InputMaybe<PagerInput>;
  sort?: InputMaybe<GetDeviceReportSort>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<DeviceProcedureExecutionStatusEnum>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetDeviceReportResponse = {
  __typename?: 'GetDeviceReportResponse';
  items?: Maybe<Array<Maybe<GetDeviceReportData>>>;
  pager?: Maybe<PagerResponse>;
  records?: Maybe<NumberOfProceduresType>;
};

export type GetDeviceReportSort = {
  deviceName?: InputMaybe<OrderDirection>;
  procedureName?: InputMaybe<OrderDirection>;
  reportDate?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  userId?: InputMaybe<OrderDirection>;
};

export type GetDeviceReportTotalInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId?: InputMaybe<Scalars['UUID']['input']>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
  sort?: InputMaybe<GetDeviceReportTotalSort>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetDeviceReportTotalResponse = {
  __typename?: 'GetDeviceReportTotalResponse';
  items?: Maybe<Array<Maybe<DeviceReportTotalItem>>>;
  pager?: Maybe<PagerResponse>;
  totalRecords?: Maybe<TotalRecordsType>;
};

export type GetDeviceReportTotalSort = {
  allReports?: InputMaybe<OrderDirection>;
  departmentName?: InputMaybe<OrderDirection>;
  failedAudits?: InputMaybe<OrderDirection>;
  groupName?: InputMaybe<OrderDirection>;
};

export type GetDeviceResponse = {
  __typename?: 'GetDeviceResponse';
  device?: Maybe<Device>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GetDevicesInput = {
  departmentId?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  departmentNameSort?: InputMaybe<OrderDirection>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  groupNameSort?: InputMaybe<OrderDirection>;
  id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  institutionId: Array<InputMaybe<Scalars['UUID']['input']>>;
  lifeCycleEndSort?: InputMaybe<OrderDirection>;
  lifeCycleStartSort?: InputMaybe<OrderDirection>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameSort?: InputMaybe<OrderDirection>;
  nextAuditDateSort?: InputMaybe<OrderDirection>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
  udi?: InputMaybe<Scalars['String']['input']>;
  updatedAtSort?: InputMaybe<OrderDirection>;
};

export type GetDevicesResponse = {
  __typename?: 'GetDevicesResponse';
  items?: Maybe<Array<Maybe<Device>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetFiveLeastFrequentlyProceduresInput = {
  departmentId: Scalars['UUID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetFiveMostAssistedProceduresInput = {
  departmentId: Scalars['UUID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetFiveMostFrequentlyProceduresInput = {
  departmentId: Scalars['UUID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetGroupInput = {
  id: Scalars['UUID']['input'];
};

export type GetGroupsInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  departmentNameSort?: InputMaybe<OrderDirection>;
  institutionId: Scalars['UUID']['input'];
  lifeCycleEndingSoonSort?: InputMaybe<OrderDirection>;
  lifeCycleSumSort?: InputMaybe<OrderDirection>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameSort?: InputMaybe<OrderDirection>;
  numberOfDevicesSort?: InputMaybe<OrderDirection>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetGroupsResponse = {
  __typename?: 'GetGroupsResponse';
  items?: Maybe<Array<Maybe<Group>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetInfrequentProceduresInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId: Scalars['UUID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetInfrequentProceduresResponse = {
  __typename?: 'GetInfrequentProceduresResponse';
  infrequentsProcedures?: Maybe<Array<Maybe<ProcedureChartDescriptionType>>>;
};

export type GetInstitutionsInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetInstitutionsResponse = {
  __typename?: 'GetInstitutionsResponse';
  items?: Maybe<Array<Maybe<Institution>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetIntensityTirednessChartInput = {
  userId: Scalars['UUID']['input'];
};

export type GetIntensityTirednessChartResponse = {
  __typename?: 'GetIntensityTirednessChartResponse';
  data?: Maybe<Array<Maybe<TirednessIntensityStats>>>;
};

export type GetLearningObjectsInput = {
  departmentId?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  institutionId: Scalars['UUID']['input'];
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetLearningObjectsResponse = {
  __typename?: 'GetLearningObjectsResponse';
  items?: Maybe<Array<Maybe<LearningObject>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetMlDataInput = {
  departmentId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  institutionId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  patientId: Scalars['UUID']['input'];
  procedureId: Scalars['UUID']['input'];
  shiftId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type GetMlDataResponse = {
  __typename?: 'GetMLDataResponse';
  isProcedureAssistanceRecommended?: Maybe<Scalars['Int']['output']>;
  predictionId?: Maybe<Scalars['Int']['output']>;
};

export type GetMissedDeviceProceduresInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  institutionId?: InputMaybe<Scalars['UUID']['input']>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetMissedDeviceProceduresResponse = {
  __typename?: 'GetMissedDeviceProceduresResponse';
  items?: Maybe<Array<Maybe<DeviceProcedureExecution>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetMostPopularProceduresInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId: Scalars['UUID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetMostPopularProceduresResponse = {
  __typename?: 'GetMostPopularProceduresResponse';
  mostPopularProcedures?: Maybe<Array<Maybe<ProcedureChartDescriptionType>>>;
};

export type GetNumberOfExecutedProceduresInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  deviceProcedureExecutionStatus?: InputMaybe<DeviceProcedureExecutionStatusEnum>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  groupId: Scalars['UUID']['input'];
  groupProcedureId?: InputMaybe<Scalars['UUID']['input']>;
  institutionId?: InputMaybe<Scalars['UUID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetNumberOfExecutedProceduresResponse = {
  __typename?: 'GetNumberOfExecutedProceduresResponse';
  data?: Maybe<Array<Maybe<NumberOfExecutedProceduresResponseData>>>;
  dates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
};

export type GetNurseAgeExperienceStatsInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId: Scalars['UUID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetNurseAgeStatsInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId: Scalars['UUID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetNursesExperienceInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  institutionId: Scalars['UUID']['input'];
};

export type GetNursesGenderChartInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  institutionId: Scalars['UUID']['input'];
};

export type GetNursesGenderChartResponse = {
  __typename?: 'GetNursesGenderChartResponse';
  dates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  females?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  males?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type GetOftenAssistedProceduresResponse = {
  __typename?: 'GetOftenAssistedProceduresResponse';
  oftenAssistedProcedures?: Maybe<Array<Maybe<ProcedureChartDescriptionType>>>;
};

export type GetPatientInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetPatientProcedureInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetPatientProcedureResponse = {
  __typename?: 'GetPatientProcedureResponse';
  end?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  procedureUuid?: Maybe<Scalars['UUID']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type GetPatientVisitInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetPatientsInput = {
  departmentUuid?: InputMaybe<Scalars['UUID']['input']>;
  institutionUuid?: InputMaybe<Scalars['UUID']['input']>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetPatientsResponse = {
  __typename?: 'GetPatientsResponse';
  items?: Maybe<Array<Maybe<Patient>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetProcedureFeedbackQuestionInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type GetProcedureFeedbackQuestionResponse = {
  __typename?: 'GetProcedureFeedbackQuestionResponse';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<ProcedureFeedbackQuestionOption>>>;
  question?: Maybe<Scalars['String']['output']>;
};

export type GetProcedureFeedbackQuestionsInput = {
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetProcedureFeedbackQuestionsResponse = {
  __typename?: 'GetProcedureFeedbackQuestionsResponse';
  items?: Maybe<Array<Maybe<GetProcedureFeedbackQuestionResponse>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetProcedureStepExecutionsInput = {
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetProcedureStepExecutionsResponse = {
  __typename?: 'GetProcedureStepExecutionsResponse';
  items?: Maybe<Array<Maybe<ProcedureStepExecutionItem>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetProceduresInput = {
  code?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  departmentId?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  institutionId?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetProceduresResponse = {
  __typename?: 'GetProceduresResponse';
  items?: Maybe<Array<Maybe<Procedure>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetQuestionInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<QuestionType>;
};

export type GetRateOfFailedAuditsInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  institutionId?: InputMaybe<Scalars['UUID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetRateOfFailedAuditsResponse = {
  __typename?: 'GetRateOfFailedAuditsResponse';
  failedAudits?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GetRolesInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<SearchInput>;
};

export type GetRolesResponse = {
  __typename?: 'GetRolesResponse';
  items?: Maybe<Array<Maybe<Role>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetShiftAverageDurationChartInput = {
  departmentId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  institutionId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  userId: Scalars['UUID']['input'];
};

export type GetShiftAverageDurationChartResponse = {
  __typename?: 'GetShiftAverageDurationChartResponse';
  data?: Maybe<Array<Maybe<AverageDurationStats>>>;
};

export type GetShiftCountInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId: Scalars['UUID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetShiftCountResponse = {
  __typename?: 'GetShiftCountResponse';
  countVsPreviousMonth?: Maybe<Scalars['Float']['output']>;
  shiftCount?: Maybe<Scalars['Float']['output']>;
};

export type GetShiftIntensityChartInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  institutionId: Scalars['UUID']['input'];
  questionId?: InputMaybe<Scalars['UUID']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetShiftIntensityChartResponse = {
  __typename?: 'GetShiftIntensityChartResponse';
  data: Array<KeyValue>;
  label?: Maybe<Scalars['String']['output']>;
};

export type GetShiftIntensityQuestionsInput = {
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetShiftIntensityQuestionsResponse = {
  __typename?: 'GetShiftIntensityQuestionsResponse';
  items?: Maybe<Array<Maybe<ShiftIntensityQuestion>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetShiftOverviewChartInput = {
  userId: Scalars['UUID']['input'];
};

export type GetShiftOverviewChartResponse = {
  __typename?: 'GetShiftOverviewChartResponse';
  data?: Maybe<Array<Maybe<OverviewStats>>>;
};

export type GetShiftPatientsInput = {
  shiftUuid: Scalars['UUID']['input'];
};

export type GetShiftPatientsResponse = {
  __typename?: 'GetShiftPatientsResponse';
  patients?: Maybe<Array<Maybe<Patient>>>;
};

export type GetShiftRouteInput = {
  addresses?: InputMaybe<Array<InputMaybe<PatientAddressInput>>>;
  initAddress?: InputMaybe<Scalars['String']['input']>;
  shiftUuid: Scalars['UUID']['input'];
};

export type GetShiftRouteResponse = {
  __typename?: 'GetShiftRouteResponse';
  patientAddresses?: Maybe<Array<Maybe<PatientAddress>>>;
  routeData?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GetShiftTiredenessQuestionsInput = {
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetShiftTiredenessQuestionsResponse = {
  __typename?: 'GetShiftTiredenessQuestionsResponse';
  items?: Maybe<Array<Maybe<ShiftTiredenessQuestion>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetShiftTirednessChartInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  institutionId: Scalars['UUID']['input'];
  questionId?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetShiftTirednessChartResponse = {
  __typename?: 'GetShiftTirednessChartResponse';
  data: Array<KeyValue>;
  label?: Maybe<Scalars['String']['output']>;
};

export type GetShiftVisitsInput = {
  shiftId: Scalars['UUID']['input'];
};

export type GetStudiesInput = {
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  institutionId: Scalars['UUID']['input'];
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetStudiesResponse = {
  __typename?: 'GetStudiesResponse';
  items?: Maybe<Array<Maybe<Study>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetSurveyChartDataInput = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  departmentId: Scalars['UUID']['input'];
  institutionId?: InputMaybe<Scalars['UUID']['input']>;
  surveyId: Scalars['UUID']['input'];
};

export type GetSurveyChartDataResponse = {
  __typename?: 'GetSurveyChartDataResponse';
  datasets: Array<ChartDataCategoryResult>;
  labels: Array<Scalars['String']['output']>;
};

export type GetSurveyChartsInput = {
  studyId: Scalars['UUID']['input'];
};

export type GetSurveyChartsResponse = {
  __typename?: 'GetSurveyChartsResponse';
  CBI?: Maybe<Array<Maybe<CbiChartData>>>;
  UWES?: Maybe<Array<Maybe<UwesChartData>>>;
  dates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
};

export type GetSurveyResultInput = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  institutionId?: InputMaybe<Scalars['UUID']['input']>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
  surveyId: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetSurveyResultResponse = {
  __typename?: 'GetSurveyResultResponse';
  items?: Maybe<Array<Maybe<SurveyResult>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetSurveysInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  institutionId: Scalars['UUID']['input'];
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
  studyId?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type GetSurveysResponse = {
  __typename?: 'GetSurveysResponse';
  items?: Maybe<Array<Maybe<Survey>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetUpcomingDeviceProceduresInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  institutionId?: InputMaybe<Scalars['UUID']['input']>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetUpcomingDeviceProceduresResponse = {
  __typename?: 'GetUpcomingDeviceProceduresResponse';
  items?: Maybe<Array<Maybe<DeviceProcedureExecution>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetUserActivityLogInput = {
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
  userId: Scalars['UUID']['input'];
};

export type GetUserActivityLogResponse = {
  __typename?: 'GetUserActivityLogResponse';
  items?: Maybe<Array<Maybe<ActivityLogEntry>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetUserProcedureOverviewInput = {
  departmentId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetUserProcedureOverviewResponse = {
  __typename?: 'GetUserProcedureOverviewResponse';
  data?: Maybe<Array<Maybe<ProcedureOverview>>>;
};

export type GetUsersInput = {
  departmentId?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  institutionId?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  pager?: InputMaybe<PagerInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
  subscription?: InputMaybe<Scalars['String']['input']>;
};

export type GetUsersResponse = {
  __typename?: 'GetUsersResponse';
  activeCount?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<User>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetVisitsByTimePeriodInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  institutionId?: InputMaybe<Scalars['UUID']['input']>;
  nurseId?: InputMaybe<Scalars['UUID']['input']>;
  pager?: InputMaybe<PagerInput>;
  patientId?: InputMaybe<Scalars['UUID']['input']>;
  timeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  timeTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetVisitsByTimePeriodResponse = {
  __typename?: 'GetVisitsByTimePeriodResponse';
  items?: Maybe<Array<Maybe<PatientVisit>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetVisitsOfNurseInput = {
  nurseId: Scalars['UUID']['input'];
};

export type GetVisitsOfPatientInput = {
  patientId: Scalars['UUID']['input'];
};

export type GetVisitsOfUserInput = {
  userId: Scalars['UUID']['input'];
};

export type GrantUserRoleInput = {
  approvalId?: InputMaybe<Scalars['ID']['input']>;
  departmentUuid: Scalars['UUID']['input'];
  institutionUuid: Scalars['UUID']['input'];
  roleUuid: Scalars['UUID']['input'];
  userUuid: Scalars['UUID']['input'];
};

export type GrantUserRoleResponse = {
  __typename?: 'GrantUserRoleResponse';
  approvalRequest?: Maybe<ApprovalRequest>;
  role?: Maybe<UserDepartmentRole>;
};

export type Group = {
  __typename?: 'Group';
  auditComingSoon?: Maybe<Scalars['Int']['output']>;
  auditFrequency?: Maybe<Scalars['Int']['output']>;
  auditProcedure?: Maybe<GroupProcedure>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Department>;
  departmentUuid?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Array<Maybe<Device>>>;
  id?: Maybe<Scalars['UUID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  institution?: Maybe<Institution>;
  institutionUuid?: Maybe<Scalars['UUID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  learningObject?: Maybe<Array<Maybe<LearningObject>>>;
  lifeCycleEndingSoon?: Maybe<Scalars['Int']['output']>;
  lifeCycleNum?: Maybe<Scalars['Int']['output']>;
  lifeCycleTime?: Maybe<LifeCycleTimeEnum>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfDevices?: Maybe<Scalars['Int']['output']>;
  procedure?: Maybe<Array<Maybe<GroupProcedure>>>;
  procedures?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userManuals?: Maybe<Scalars['UUID']['output']>;
};

export type GroupProcedure = {
  __typename?: 'GroupProcedure';
  author?: Maybe<User>;
  category?: Maybe<Category>;
  checklist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code: Scalars['UUID']['output'];
  comments?: Maybe<Array<Maybe<CommentType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['UUID']['output'];
  createdByType: ActorType;
  departments?: Maybe<Array<Maybe<Department>>>;
  description?: Maybe<Scalars['String']['output']>;
  frequencyNum?: Maybe<Scalars['Int']['output']>;
  frequencyPeriod?: Maybe<FrequencyPeriodEnum>;
  groupProcedureUuid?: Maybe<Scalars['UUID']['output']>;
  groupUuid?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isAudit?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  patient?: Maybe<Array<Maybe<Patient>>>;
  status?: Maybe<ProcedureStatus>;
  steps: Array<Maybe<ProcedureStep>>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export enum GroupProcedureTypeEnum {
  Audit = 'AUDIT'
}

export type Institution = {
  __typename?: 'Institution';
  administrators?: Maybe<Array<Maybe<User>>>;
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  cvi?: Maybe<Scalars['JSONObject']['output']>;
  departments?: Maybe<Array<Maybe<Department>>>;
  house?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stopDetectionDuration?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export type InstitutionSubscription = {
  __typename?: 'InstitutionSubscription';
  admin?: Maybe<Scalars['Boolean']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByType?: Maybe<CreatedByType>;
  end?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institutionUuid: Scalars['ID']['output'];
  start?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SubscriptionStatus>;
  stripeCustomerUuid?: Maybe<Scalars['String']['output']>;
  stripePlan?: Maybe<StripePlan>;
};

export type IntensitySurveyResultInputItem = {
  answer: Scalars['Int']['input'];
  questionID: Scalars['UUID']['input'];
};

export type IntensitySurveyResultItem = {
  __typename?: 'IntensitySurveyResultItem';
  answer: Scalars['Int']['output'];
  questionID: Scalars['UUID']['output'];
};

export type InviteStub = {
  __typename?: 'InviteStub';
  email: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type InviteUserInput = {
  admin1Signature?: InputMaybe<Scalars['String']['input']>;
  admin2Signature?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['UUID']['input'];
  email: Scalars['String']['input'];
  institutionId: Scalars['UUID']['input'];
  permissionString?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['UUID']['input'];
};

export type InviteUserResponse = {
  __typename?: 'InviteUserResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type KeyValue = {
  __typename?: 'KeyValue';
  key: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type LearningObject = {
  __typename?: 'LearningObject';
  author?: Maybe<User>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  departments?: Maybe<Array<Maybe<Department>>>;
  id?: Maybe<Scalars['UUID']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<LearningObjectPermission>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export enum LearningObjectPermission {
  Department = 'DEPARTMENT',
  Institution = 'INSTITUTION',
  Public = 'PUBLIC'
}

export enum LifeCycleTimeEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type MlConfirmationInput = {
  predictionId: Scalars['Int']['input'];
  wasRecommendationUsed: Scalars['Boolean']['input'];
};

export type MlConfirmationResponse = {
  __typename?: 'MLConfirmationResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export enum MlSurveyLanguagesEnum {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Ru = 'RU'
}

export enum MlSurveyTypeEnum {
  Cbi = 'CBI',
  Uwes = 'UWES'
}

export type MediaQuestion = {
  __typename?: 'MediaQuestion';
  imageBase64?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type MedicationInput = {
  dosage: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  frequency: Scalars['String']['input'];
  medication: Scalars['String']['input'];
  medicationType: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type MedicationType = {
  __typename?: 'MedicationType';
  dosage?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  medication?: Maybe<Scalars['String']['output']>;
  medicationType?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export enum MlFeatureSubtypeEnum {
  Absorption = 'ABSORPTION',
  Dedication = 'DEDICATION',
  PatientBurnout = 'PATIENT_BURNOUT',
  PersonalBurnout = 'PERSONAL_BURNOUT',
  Vigor = 'VIGOR',
  WorkBurnout = 'WORK_BURNOUT'
}

export enum MlFeatureTypeEnum {
  Cbi = 'CBI',
  Uwes = 'UWES'
}

export type MostAssistedProceduresChart = {
  __typename?: 'MostAssistedProceduresChart';
  numberOfSuggestedAssistances?: Maybe<Scalars['Int']['output']>;
  procedure?: Maybe<Procedure>;
  vsPrevious?: Maybe<Scalars['Float']['output']>;
};

export type MultiChoiceQuestion = {
  __typename?: 'MultiChoiceQuestion';
  answers?: Maybe<Array<Maybe<ScaleAnswer>>>;
  question?: Maybe<Scalars['String']['output']>;
  selectedAnswers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  MLFeedback?: Maybe<MlConfirmationResponse>;
  _?: Maybe<Scalars['Boolean']['output']>;
  addChecklistQuestion: ChecklistQuestion;
  addConsent: ConsentResponse;
  addMLSurvey: AddMlSurveyResponse;
  addPatient: AddPatientResponse;
  addPatientProcedure: AddPatientProcedureResponse;
  addPatientToUser: AddPatientToUserResponse;
  addPatientVisit: AddPatientVisitResponse;
  addShiftPatient: Array<Maybe<ShiftPatient>>;
  approveAction: ApprovalRequest;
  createAcuity: CreateAcuityResponse;
  createBillingPortalSession: CreateBillingPortalPayload;
  createCategory: CreateCategoryResponse;
  createChecklistAnswer: ChecklistAnswer;
  createChecklistPreset: ChecklistPreset;
  /** Створити Stripe Checkout-сесію для оформлення підписки */
  createCheckoutSession?: Maybe<CheckoutSession>;
  createDepartment: CreateDepartmentResponse;
  createDevice: CreateDeviceResponse;
  createDeviceComment: CreateDeviceCommentResponse;
  createDeviceProcedureExecution: CreateDeviceProcedureExecutionResponse;
  createDevices: Array<CreateDeviceResponse>;
  createGroup: CreateGroupResponse;
  createGroupProcedure: CreateGroupProcedureResponse;
  createInstitution: CreateInstitutionResponse;
  createInstitutionWithAdminAndDepartmentInput: CreateInstitutionWithAdminAndDepartmentPayload;
  createLearningObject: CreateLearningObjectResponse;
  createProcedure: CreateProcedureResponse;
  createProcedureExecution: CreateProcedureExecutionResponse;
  createProcedureFeedbackAnswer: CreateProcedureFeedbackAnswerResponse;
  createProcedureStepExecution: AddProcedureStepExecutionResponse;
  createQuestion: CreateQuestionResponse;
  createShift: CreateShiftResponse;
  createStudy: CreateStudyResponse;
  createSurvey: CreateSurveyResponse;
  createSurveyResult: CreateSurveyResultResponse;
  createUserProcedureExperience: CreateUserProcedureExperienceResponse;
  createVisitChecklist: VisitChecklist;
  createVisitType: VisitType;
  deleteAcuity: DeleteAcuityResponse;
  deleteCategory: DeleteCategoryResponse;
  deleteChecklistAnswer?: Maybe<Scalars['Boolean']['output']>;
  deleteChecklistPreset?: Maybe<Scalars['Boolean']['output']>;
  deleteChecklistQuestion?: Maybe<Scalars['Boolean']['output']>;
  deleteDepartment: DeleteDepartmentResponse;
  deleteDevice: DeleteDeviceResponse;
  deleteDeviceProcedureExecution: DeleteDeviceProcedureExecutionResponse;
  deleteGroup: DeleteGroupResponse;
  deleteLearningObject: DeleteLearningObjectResponse;
  deletePatient: DeletePatientResponse;
  deletePatientFromUser: DeletePatientFromUserResponse;
  deletePatientProcedure: DeletePatientProcedureResponse;
  deletePatientVisit: DeletePatientVisitResponse;
  deleteProcedure: DeleteProcedureResponse;
  deleteProcedureExecution: DeleteProcedureExecutionResponse;
  deleteProcedureStepExecution: DeleteProcedureStepExecutionResponse;
  deleteQuestion: DeleteQuestionResponse;
  deleteQuestionCategory: DeleteQuestionCategoryResponse;
  deleteShift: DeleteShiftResponse;
  deleteShiftPatient: Array<Maybe<ShiftPatient>>;
  deleteStudy: DeleteStudyResponse;
  deleteSurvey: DeleteSurveyResponse;
  deleteUsers: DeleteUsersResponse;
  deleteVisitChecklist?: Maybe<Scalars['Boolean']['output']>;
  deleteVisitType?: Maybe<Scalars['Boolean']['output']>;
  disableUsers: DisableUsersResponse;
  enableUsers: EnableUsersResponse;
  endShift: EndShiftResponse;
  grantUserRole: GrantUserRoleResponse;
  inviteUser: InviteUserResponse;
  movePatientFromShift: MovePatientFromShiftResponse;
  movePatientToUser: MovePatientToUserResponse;
  reInviteUser: ReInviteUserResponse;
  rejectAction: ApprovalRequest;
  resetUserPassword: ResetUserPasswordResponse;
  revokeUserRole: RevokeUserRoleResponse;
  signupUser: SignupUserResponse;
  signupUserStartTrial: SignupUserStartTrialPayload;
  updateAcuity: UpdateAcuityResponse;
  updateCategory: UpdateCategoryResponse;
  updateChecklistAnswer: ChecklistAnswer;
  updateChecklistPreset: ChecklistPreset;
  updateChecklistQuestion: ChecklistQuestion;
  updateDepartment: UpdateDepartmentResponse;
  updateDevice: CreateDeviceResponse;
  updateDeviceProcedureExecution: UpdateDeviceProcedureExecutionResponse;
  updateDeviceProcedureExecutionStatus: UpdateDeviceProcedureExecutionStatusResponse;
  updateGroup: CreateGroupResponse;
  updateInstitution: UpdateInstitutionResponse;
  updateLearningObject: UpdateLearningObjectResponse;
  updatePatient: UpdatePatientResponse;
  updatePatientProcedure: UpdatePatientProcedureResponse;
  updatePatientVisit: UpdatePatientVisitResponse;
  updateProcedure: CreateProcedureResponse;
  updateProcedureExecution: UpdateProcedureExecutionResponse;
  updateProcedureStepExecution: UpdateProcedureStepExecutionResponse;
  updateQuestion?: Maybe<UpdateQuestionResponse>;
  updateQuestionPosition?: Maybe<UpdateQuestionPositionResponse>;
  updateShift: UpdateShiftResponse;
  updateShiftEndTime: UpdateShiftEndTimeResponse;
  updateStudy: UpdateStudyResponse;
  updateSurvey: UpdateSurveyResponse;
  updateSurveyPosition: UpdateSurveyPositionResponse;
  updateUser: UpdateUserResponse;
  updateUserProcedureExperience: UpdateUserProcedureExperienceResponse;
  updateVisitChecklist: VisitChecklist;
  updateVisitType: VisitType;
};


export type MutationMlFeedbackArgs = {
  input: MlConfirmationInput;
};


export type MutationAddChecklistQuestionArgs = {
  input: CreateChecklistQuestionInput;
};


export type MutationAddConsentArgs = {
  input?: InputMaybe<ConsentInput>;
};


export type MutationAddMlSurveyArgs = {
  input: AddMlSurveyInput;
};


export type MutationAddPatientArgs = {
  input: AddPatientInput;
};


export type MutationAddPatientProcedureArgs = {
  input: AddPatientProcedureInput;
};


export type MutationAddPatientToUserArgs = {
  input: AddPatientToUserInput;
};


export type MutationAddPatientVisitArgs = {
  input: AddPatientVisitInput;
};


export type MutationAddShiftPatientArgs = {
  input: AddShiftPatientInput;
};


export type MutationApproveActionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateAcuityArgs = {
  input: CreateAcuityInput;
};


export type MutationCreateBillingPortalSessionArgs = {
  input: CreateBillingPortalInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateChecklistAnswerArgs = {
  input: CreateChecklistAnswerInput;
};


export type MutationCreateChecklistPresetArgs = {
  input: CreateChecklistPresetInput;
};


export type MutationCreateCheckoutSessionArgs = {
  input: CreateCheckoutInput;
};


export type MutationCreateDepartmentArgs = {
  input: CreateDepartmentInput;
};


export type MutationCreateDeviceArgs = {
  input: CreateDeviceInput;
};


export type MutationCreateDeviceCommentArgs = {
  input: CreateDeviceCommentInput;
};


export type MutationCreateDeviceProcedureExecutionArgs = {
  input: CreateDeviceProcedureExecutionInput;
};


export type MutationCreateDevicesArgs = {
  input: Array<CreateDeviceInput>;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateGroupProcedureArgs = {
  input: CreateGroupProcedureInput;
};


export type MutationCreateInstitutionArgs = {
  input: CreateInstitutionInput;
};


export type MutationCreateInstitutionWithAdminAndDepartmentInputArgs = {
  input: CreateInstitutionWithAdminAndDepartmentInput;
};


export type MutationCreateLearningObjectArgs = {
  input: CreateLearningObjectInput;
};


export type MutationCreateProcedureArgs = {
  input: CreateProcedureInput;
};


export type MutationCreateProcedureExecutionArgs = {
  input: CreateProcedureExecutionInput;
};


export type MutationCreateProcedureFeedbackAnswerArgs = {
  input: CreateProcedureFeedbackAnswerInput;
};


export type MutationCreateProcedureStepExecutionArgs = {
  input: AddProcedureStepExecutionInput;
};


export type MutationCreateQuestionArgs = {
  input: CreateQuestionInput;
};


export type MutationCreateShiftArgs = {
  input: CreateShiftInput;
};


export type MutationCreateStudyArgs = {
  input: CreateStudyInput;
};


export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
};


export type MutationCreateSurveyResultArgs = {
  input: CreateSurveyResultInput;
};


export type MutationCreateUserProcedureExperienceArgs = {
  input: CreateUserProcedureExperienceInput;
};


export type MutationCreateVisitChecklistArgs = {
  input: CreateVisitChecklistInput;
};


export type MutationCreateVisitTypeArgs = {
  input: CreateVisitTypeInput;
};


export type MutationDeleteAcuityArgs = {
  input: DeleteAcuityInput;
};


export type MutationDeleteCategoryArgs = {
  input: DeleteCategoryInput;
};


export type MutationDeleteChecklistAnswerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteChecklistPresetArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteChecklistQuestionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteDepartmentArgs = {
  input: DeleteDepartmentInput;
};


export type MutationDeleteDeviceArgs = {
  input: DeleteDeviceInput;
};


export type MutationDeleteDeviceProcedureExecutionArgs = {
  input: DeleteDeviceProcedureExecutionInput;
};


export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


export type MutationDeleteLearningObjectArgs = {
  input: DeleteLearningObjectInput;
};


export type MutationDeletePatientArgs = {
  input: DeletePatientInput;
};


export type MutationDeletePatientFromUserArgs = {
  input: DeletePatientFromUserInput;
};


export type MutationDeletePatientProcedureArgs = {
  input: DeletePatientProcedureInput;
};


export type MutationDeletePatientVisitArgs = {
  input: DeletePatientVisitInput;
};


export type MutationDeleteProcedureArgs = {
  input: DeleteProcedureInput;
};


export type MutationDeleteProcedureExecutionArgs = {
  input: DeleteProcedureExecutionInput;
};


export type MutationDeleteProcedureStepExecutionArgs = {
  input: DeleteProcedureStepExecutionInput;
};


export type MutationDeleteQuestionArgs = {
  input: DeleteQuestionInput;
};


export type MutationDeleteQuestionCategoryArgs = {
  input: DeleteQuestionCategoryInput;
};


export type MutationDeleteShiftArgs = {
  input: DeleteShiftInput;
};


export type MutationDeleteShiftPatientArgs = {
  input: DeleteShiftPatientInput;
};


export type MutationDeleteStudyArgs = {
  input: DeleteStudyInput;
};


export type MutationDeleteSurveyArgs = {
  input: DeleteSurveyInput;
};


export type MutationDeleteUsersArgs = {
  input: DeleteUsersInput;
};


export type MutationDeleteVisitChecklistArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteVisitTypeArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDisableUsersArgs = {
  input: DisableUsersInput;
};


export type MutationEnableUsersArgs = {
  input: EnableUsersInput;
};


export type MutationEndShiftArgs = {
  input: EndShiftInput;
};


export type MutationGrantUserRoleArgs = {
  input: GrantUserRoleInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationMovePatientFromShiftArgs = {
  input: MovePatientFromShiftInput;
};


export type MutationMovePatientToUserArgs = {
  input: MovePatientToUserInput;
};


export type MutationReInviteUserArgs = {
  input: ReInviteUserInput;
};


export type MutationRejectActionArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


export type MutationRevokeUserRoleArgs = {
  input: RevokeUserRoleInput;
};


export type MutationSignupUserArgs = {
  input: SignupUserInput;
};


export type MutationSignupUserStartTrialArgs = {
  input: SignupUserStartTrialInput;
};


export type MutationUpdateAcuityArgs = {
  input: UpdateAcuityInput;
};


export type MutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


export type MutationUpdateChecklistAnswerArgs = {
  input: UpdateChecklistAnswerInput;
};


export type MutationUpdateChecklistPresetArgs = {
  input: UpdateChecklistPresetInput;
};


export type MutationUpdateChecklistQuestionArgs = {
  input: UpdateChecklistQuestionInput;
};


export type MutationUpdateDepartmentArgs = {
  input: UpdateDepartmentInput;
};


export type MutationUpdateDeviceArgs = {
  input: UpdateDeviceInput;
};


export type MutationUpdateDeviceProcedureExecutionArgs = {
  input: UpdateDeviceProcedureExecutionInput;
};


export type MutationUpdateDeviceProcedureExecutionStatusArgs = {
  input: UpdateDeviceProcedureExecutionStatusInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateInstitutionArgs = {
  input: UpdateInstitutionInput;
};


export type MutationUpdateLearningObjectArgs = {
  input: UpdateLearningObjectInput;
};


export type MutationUpdatePatientArgs = {
  input: UpdatePatientInput;
};


export type MutationUpdatePatientProcedureArgs = {
  input: UpdatePatientProcedureInput;
};


export type MutationUpdatePatientVisitArgs = {
  input: UpdatePatientVisitInput;
};


export type MutationUpdateProcedureArgs = {
  input: UpdateProcedureInput;
};


export type MutationUpdateProcedureExecutionArgs = {
  input: UpdateProcedureExecutionInput;
};


export type MutationUpdateProcedureStepExecutionArgs = {
  input: UpdateProcedureStepExecutionInput;
};


export type MutationUpdateQuestionArgs = {
  input: UpdateQuestionInput;
};


export type MutationUpdateQuestionPositionArgs = {
  input: UpdateQuestionPositionInput;
};


export type MutationUpdateShiftArgs = {
  input: UpdateShiftInput;
};


export type MutationUpdateShiftEndTimeArgs = {
  input: UpdateShiftEndTimeInput;
};


export type MutationUpdateStudyArgs = {
  input: UpdateStudyInput;
};


export type MutationUpdateSurveyArgs = {
  input: UpdateSurveyInput;
};


export type MutationUpdateSurveyPositionArgs = {
  input: UpdateSurveyPositionInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserProcedureExperienceArgs = {
  input: UpdateUserProcedureExperienceInput;
};


export type MutationUpdateVisitChecklistArgs = {
  input: UpdateVisitChecklistInput;
};


export type MutationUpdateVisitTypeArgs = {
  input: UpdateVisitTypeInput;
};

export type NumberOfExecutedProceduresResponseData = {
  __typename?: 'NumberOfExecutedProceduresResponseData';
  dataset?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  groupProcedureId?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  procedureId?: Maybe<Scalars['UUID']['output']>;
};

export type NurseArrivalsInput = {
  departmentUuid?: InputMaybe<Scalars['UUID']['input']>;
  institutionUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type NurseArrivalsResponse = {
  __typename?: 'NurseArrivalsResponse';
  address?: Maybe<Scalars['String']['output']>;
  department_name?: Maybe<Scalars['String']['output']>;
  department_uuid?: Maybe<Scalars['UUID']['output']>;
  institution_name?: Maybe<Scalars['String']['output']>;
  institution_uuid?: Maybe<Scalars['UUID']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patient_name?: Maybe<Scalars['String']['output']>;
  time_arrive?: Maybe<Scalars['DateTime']['output']>;
  time_leave?: Maybe<Scalars['DateTime']['output']>;
  user_uuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  visit_uuid?: Maybe<Scalars['String']['output']>;
};

export type NurseInfoCombinedInput = {
  dateTimeFrom: Scalars['DateTime']['input'];
  dateTimeTo: Scalars['DateTime']['input'];
  userUuid: Scalars['UUID']['input'];
};

export type NurseInfoCombinedResponse = {
  __typename?: 'NurseInfoCombinedResponse';
  arrivals?: Maybe<Array<Maybe<NurseArrivalsResponse>>>;
  locations?: Maybe<Array<Maybe<NurseLocationsResponse>>>;
};

export type NurseLocationsInput = {
  departmentUuid?: InputMaybe<Scalars['UUID']['input']>;
  institutionUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type NurseLocationsResponse = {
  __typename?: 'NurseLocationsResponse';
  department_name?: Maybe<Scalars['String']['output']>;
  department_uuid?: Maybe<Scalars['UUID']['output']>;
  institution_name?: Maybe<Scalars['String']['output']>;
  institution_uuid?: Maybe<Scalars['UUID']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['DateTime']['output']>;
  user_uuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type NurseRouteInput = {
  dateTimeFrom: Scalars['DateTime']['input'];
  dateTimeTo: Scalars['DateTime']['input'];
  departmentUuid?: InputMaybe<Scalars['UUID']['input']>;
  institutionUuid: Scalars['UUID']['input'];
  userUuid: Scalars['UUID']['input'];
};

export type NurseRoutePoint = {
  __typename?: 'NurseRoutePoint';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  time: Scalars['DateTime']['output'];
};

export type NurseRouteResponse = {
  __typename?: 'NurseRouteResponse';
  points: Array<NurseRoutePoint>;
  stops: Array<NurseRouteStop>;
  timezone: Scalars['String']['output'];
};

export type NurseRouteStop = {
  __typename?: 'NurseRouteStop';
  address: Scalars['String']['output'];
  durationMinutes: Scalars['Int']['output'];
  endTime: Scalars['DateTime']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type NursesInfoCombinedInput = {
  dateTimeFrom: Scalars['DateTime']['input'];
  dateTimeTo: Scalars['DateTime']['input'];
  departmentUuid: Scalars['UUID']['input'];
  institutionUuid: Scalars['UUID']['input'];
};

export type NursesInfoCombinedResponse = {
  __typename?: 'NursesInfoCombinedResponse';
  arrivals?: Maybe<Array<Maybe<NurseArrivalsResponse>>>;
  departmentName?: Maybe<Scalars['String']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<NurseLocationsResponse>>>;
  name?: Maybe<Scalars['UUID']['output']>;
  user_uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type OrderInput = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type OverviewStats = {
  __typename?: 'OverviewStats';
  acuityScore?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  intensityScore?: Maybe<Scalars['Float']['output']>;
};

export type PagerInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type PagerResponse = {
  __typename?: 'PagerResponse';
  activeCount?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type Patient = {
  __typename?: 'Patient';
  activeShift?: Maybe<ShiftData>;
  acuity?: Maybe<Array<Maybe<AcuityType>>>;
  address?: Maybe<Scalars['String']['output']>;
  admissionDate?: Maybe<Scalars['Date']['output']>;
  allergy?: Maybe<Array<Maybe<AllergyType>>>;
  assignedProcedure?: Maybe<Array<Maybe<ProcedureExecutionItemType>>>;
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<Scalars['UUID']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['UUID']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  departmentUuid?: Maybe<Scalars['UUID']['output']>;
  dischargeDate?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  finishedProcedure?: Maybe<Array<Maybe<ProcedureExecutionItemType>>>;
  gender?: Maybe<PatientGender>;
  house?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  identification?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastAcuity?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  medication?: Maybe<Array<Maybe<MedicationType>>>;
  missedProcedure?: Maybe<Array<Maybe<ProcedureExecutionItemType>>>;
  name?: Maybe<Scalars['String']['output']>;
  nextVisit?: Maybe<PatientVisit>;
  nurseUuid?: Maybe<Scalars['UUID']['output']>;
  patientType?: Maybe<PatientTypeEnum>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primaryDiagnosis?: Maybe<Scalars['String']['output']>;
  procedure?: Maybe<Array<Maybe<ProcedureExecutionItemType>>>;
  scheduledProcedure?: Maybe<Array<Maybe<ProcedureExecutionItemType>>>;
  secondaryDiagnosis?: Maybe<Scalars['String']['output']>;
  shiftUuid?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<Scalars['UUID']['output']>;
  user?: Maybe<Array<Maybe<User>>>;
  visitHistory?: Maybe<Array<Maybe<PatientVisit>>>;
};


export type PatientAcuityArgs = {
  input?: InputMaybe<SortByInput>;
};


export type PatientAssignedProcedureArgs = {
  input?: InputMaybe<SortByInput>;
};


export type PatientFinishedProcedureArgs = {
  input?: InputMaybe<SortByInput>;
};


export type PatientMissedProcedureArgs = {
  input?: InputMaybe<SortByInput>;
};


export type PatientProcedureArgs = {
  input?: InputMaybe<PatientProceduresFilterInput>;
};


export type PatientScheduledProcedureArgs = {
  input?: InputMaybe<SortByInput>;
};

export type PatientAddress = {
  __typename?: 'PatientAddress';
  address: Scalars['String']['output'];
  patientId: Scalars['UUID']['output'];
  patientName: Scalars['String']['output'];
};

export type PatientAddressInput = {
  address: Scalars['String']['input'];
  patientId: Scalars['UUID']['input'];
  patientName: Scalars['String']['input'];
};

export type PatientDataUpdate = {
  acuity?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  admissionDate?: InputMaybe<Scalars['Date']['input']>;
  allergy?: InputMaybe<Array<InputMaybe<AllergyInput>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  conditionCode?: InputMaybe<Scalars['Int']['input']>;
  conditionName?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  departmentUuid?: InputMaybe<Scalars['UUID']['input']>;
  dischargeDate?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<PatientGender>;
  height?: InputMaybe<Scalars['Int']['input']>;
  house?: InputMaybe<Scalars['String']['input']>;
  identification?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  medication?: InputMaybe<Array<InputMaybe<MedicationInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nurseUuid?: InputMaybe<Scalars['UUID']['input']>;
  patientType?: InputMaybe<PatientTypeEnum>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primaryDiagnosis?: InputMaybe<Scalars['String']['input']>;
  secondaryDiagnosis?: InputMaybe<Scalars['String']['input']>;
  shiftUuid?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export enum PatientGender {
  Female = 'female',
  Male = 'male'
}

export type PatientInShiftType = {
  __typename?: 'PatientInShiftType';
  patient?: Maybe<Patient>;
  shift?: Maybe<ShiftData>;
  user?: Maybe<User>;
};

export type PatientItemType = {
  __typename?: 'PatientItemType';
  admissionDate?: Maybe<Scalars['Date']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<Scalars['UUID']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['UUID']['output']>;
  departmentUuid?: Maybe<Scalars['UUID']['output']>;
  dischargeDate?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<PatientGender>;
  house?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  identification?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shiftUuid?: Maybe<Scalars['UUID']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<Scalars['UUID']['output']>;
};

export type PatientProcedureItem = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientUuid?: InputMaybe<Scalars['UUID']['input']>;
  procedureUuid?: InputMaybe<Scalars['UUID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid?: InputMaybe<Scalars['UUID']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type PatientProcedureItemType = {
  __typename?: 'PatientProcedureItemType';
  author?: Maybe<Scalars['UUID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  categoryUuid?: Maybe<Scalars['UUID']['output']>;
  checklist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isEnabled?: Maybe<Scalars['Int']['output']>;
  isPublic?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  procedureUuid?: Maybe<Scalars['UUID']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  steps?: Maybe<Array<Maybe<ProcedureStep>>>;
  type?: Maybe<Scalars['String']['output']>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<Scalars['String']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
  versionStatus?: Maybe<Scalars['String']['output']>;
};

export type PatientProceduresFilterInput = {
  dateTime?: InputMaybe<DateRangeInput>;
  order?: InputMaybe<OrderInput>;
  procedureUuid?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
  state?: InputMaybe<Array<InputMaybe<ProcedureExecutionStateEnum>>>;
};

export type PatientType = {
  __typename?: 'PatientType';
  admissionDate?: Maybe<Scalars['Date']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  departmentUuid?: Maybe<Scalars['UUID']['output']>;
  dischargeDate?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<PatientGender>;
  house?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  identification?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shiftUuid?: Maybe<Scalars['UUID']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export enum PatientTypeEnum {
  Home = 'home',
  Hospital = 'hospital'
}

export type PatientVisit = {
  __typename?: 'PatientVisit';
  checklist?: Maybe<VisitChecklist>;
  end?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<VisitStatusEnum>;
  user?: Maybe<User>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type PatientVisitItem = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['UUID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<VisitStatusEnum>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type Procedure = {
  __typename?: 'Procedure';
  author?: Maybe<User>;
  category?: Maybe<Category>;
  checklist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code?: Maybe<Scalars['UUID']['output']>;
  comments?: Maybe<Array<Maybe<CommentType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  departments?: Maybe<Array<Maybe<Department>>>;
  description?: Maybe<Scalars['String']['output']>;
  groupProcedure?: Maybe<Array<Maybe<GroupProcedure>>>;
  id?: Maybe<Scalars['UUID']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Array<Maybe<Patient>>>;
  status?: Maybe<ProcedureStatus>;
  steps?: Maybe<Array<Maybe<ProcedureStep>>>;
  type?: Maybe<Scalars['String']['output']>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export type ProcedureChart = {
  __typename?: 'ProcedureChart';
  numberOfExecutions?: Maybe<Scalars['Int']['output']>;
  procedure?: Maybe<Procedure>;
  vsPrevious?: Maybe<Scalars['Float']['output']>;
};

export type ProcedureChartDescriptionType = {
  __typename?: 'ProcedureChartDescriptionType';
  count?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

export type ProcedureExecution = {
  __typename?: 'ProcedureExecution';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  duration?: Maybe<Scalars['Int']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  procedureUuid?: Maybe<Scalars['UUID']['output']>;
  reasonForTermination?: Maybe<ProcedureExecutionTerminationReason>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<ProcedureExecutionState>;
  terminationComment?: Maybe<Scalars['String']['output']>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export type ProcedureExecutionItemType = {
  __typename?: 'ProcedureExecutionItemType';
  category?: Maybe<Category>;
  duration?: Maybe<Scalars['Int']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  modelOutput?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientAcuity?: Maybe<Scalars['Int']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  procedureUuid?: Maybe<Scalars['UUID']['output']>;
  reasonForTermination?: Maybe<ProcedureExecutionTerminationReason>;
  scheduled?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<ProcedureExecutionStateEnum>;
  stepsExecution?: Maybe<Array<Maybe<ProcedureStepExecutionItem>>>;
  terminationComment?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export enum ProcedureExecutionState {
  Finished = 'FINISHED',
  Scheduled = 'SCHEDULED',
  Started = 'STARTED',
  Terminated = 'TERMINATED'
}

export enum ProcedureExecutionStateEnum {
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  Started = 'STARTED'
}

export enum ProcedureExecutionTerminationReason {
  Other = 'OTHER',
  PatientPain = 'PATIENT_PAIN',
  PatientUncomfortable = 'PATIENT_UNCOMFORTABLE',
  UnableToPerform = 'UNABLE_TO_PERFORM'
}

export type ProcedureFeedbackAnswer = {
  answer: Scalars['String']['input'];
  optionId: Scalars['UUID']['input'];
};

export type ProcedureFeedbackQuestionOption = {
  __typename?: 'ProcedureFeedbackQuestionOption';
  id: Scalars['UUID']['output'];
  text: Scalars['String']['output'];
};

export type ProcedureOverview = {
  __typename?: 'ProcedureOverview';
  confidenceScore?: Maybe<Scalars['Int']['output']>;
  countOfExecutions?: Maybe<Scalars['Int']['output']>;
  procedureId: Scalars['UUID']['output'];
  procedureName?: Maybe<Scalars['String']['output']>;
};

export enum ProcedureStatus {
  Finished = 'finished',
  Started = 'started',
  Stopped = 'stopped'
}

export type ProcedureStep = {
  __typename?: 'ProcedureStep';
  errors?: Maybe<Array<Maybe<StepError>>>;
  exits?: Maybe<Array<Maybe<ProcedureStepExit>>>;
  id: Scalars['UUID']['output'];
  media?: Maybe<Array<Maybe<ProcedureStepMedia>>>;
  order?: Maybe<Scalars['Float']['output']>;
  parent?: Maybe<Array<Maybe<ProcedureStepParent>>>;
  title: Scalars['String']['output'];
  transitionType: ProcedureStepExitType;
  type: ProcedureStepType;
};

export type ProcedureStepExecution = {
  __typename?: 'ProcedureStepExecution';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['UUID']['output'];
  createdByType: ActorType;
  duration?: Maybe<Scalars['Int']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  startedAt: Scalars['DateTime']['output'];
  stepExitId: Scalars['UUID']['output'];
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export type ProcedureStepExecutionItem = {
  __typename?: 'ProcedureStepExecutionItem';
  duration?: Maybe<Scalars['Int']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  parentStepUuid?: Maybe<Scalars['UUID']['output']>;
  procedureExecutionUuid?: Maybe<Scalars['UUID']['output']>;
  procedureStepUuid?: Maybe<Scalars['UUID']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<ProcedureStepExecutionState>;
  stepExitUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<ProcedureStepExecutionType>;
};

export enum ProcedureStepExecutionState {
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  Started = 'STARTED'
}

export enum ProcedureStepExecutionType {
  Device = 'DEVICE',
  Patient = 'PATIENT'
}

export type ProcedureStepExecutionUpdateItem = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  parentStepUuid?: InputMaybe<Scalars['UUID']['input']>;
  procedureExecutionUuid?: InputMaybe<Scalars['UUID']['input']>;
  procedureStepUuid?: InputMaybe<Scalars['UUID']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<ProcedureStepExecutionState>;
  stepExitUuid?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<ProcedureStepExecutionType>;
};

export type ProcedureStepExit = {
  __typename?: 'ProcedureStepExit';
  id: Scalars['UUID']['output'];
  value?: Maybe<Scalars['String']['output']>;
  valueMax?: Maybe<Scalars['Float']['output']>;
  valueMin?: Maybe<Scalars['Float']['output']>;
  valueType: ProcedureStepExitValueType;
};

export type ProcedureStepExitInput = {
  id: Scalars['UUID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
  valueMax?: InputMaybe<Scalars['Float']['input']>;
  valueMin?: InputMaybe<Scalars['Float']['input']>;
  valueType: ProcedureStepExitValueType;
};

export enum ProcedureStepExitType {
  Decision = 'DECISION',
  Measurement = 'MEASUREMENT',
  Regular = 'REGULAR'
}

export enum ProcedureStepExitValueType {
  Fixed = 'FIXED',
  None = 'NONE',
  Range = 'RANGE'
}

export type ProcedureStepInput = {
  exits?: InputMaybe<Array<InputMaybe<ProcedureStepExitInput>>>;
  id: Scalars['UUID']['input'];
  media?: InputMaybe<Array<InputMaybe<ProcedureStepMediaInput>>>;
  parent?: InputMaybe<Array<InputMaybe<ProcedureStepParentInput>>>;
  title: Scalars['String']['input'];
  transitionType: ProcedureStepExitType;
  type: ProcedureStepType;
};

export type ProcedureStepMedia = {
  __typename?: 'ProcedureStepMedia';
  bucket: Scalars['String']['output'];
  bucketFilename: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  originalFilename: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  type: ProcedureStepMediaType;
  url: Scalars['String']['output'];
};

export type ProcedureStepMediaInput = {
  bucket: Scalars['String']['input'];
  bucketFilename: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  originalFilename: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  type: ProcedureStepMediaType;
  url: Scalars['String']['input'];
};

export enum ProcedureStepMediaType {
  Audio = 'AUDIO',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type ProcedureStepParent = {
  __typename?: 'ProcedureStepParent';
  exitId: Scalars['UUID']['output'];
  stepId: Scalars['UUID']['output'];
};

export type ProcedureStepParentInput = {
  exitId: Scalars['UUID']['input'];
  stepId: Scalars['UUID']['input'];
};

export enum ProcedureStepType {
  Choice = 'CHOICE',
  End = 'END',
  Start = 'START',
  Task = 'TASK'
}

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['Boolean']['output']>;
  approvalRequests: ApprovalRequestsResponse;
  currentUser: CurrentUserResponse;
  getActiveUsers: Array<Maybe<User>>;
  getAcuity?: Maybe<GetAcuityResponse>;
  getAverageNurseAgeChart: GetAverageNurseAgeChartResponse;
  getAveragePatientAcuityData: GetAveragePatientAcuityDataResponse;
  getAverageShiftData: GetAverageShiftDataResponse;
  getAverageTimeSpentOnProcedure: GetAverageTimeSpentOnProcedureResponse;
  getAverageTiredness: GetAverageTirednessResponse;
  getCategories: GetCategoriesResponse;
  getChecklistAnswer: ChecklistAnswer;
  getChecklistAnswerByVisitId: ChecklistAnswer;
  getChecklistPreset: ChecklistPreset;
  getChecklistPresetsByDepartmentId?: Maybe<Array<ChecklistPreset>>;
  getChecklistQuestions?: Maybe<Array<ChecklistQuestion>>;
  getConsent?: Maybe<ConsentResponse>;
  getDepartments: GetDepartmentsResponse;
  getDevice: GetDeviceResponse;
  getDeviceCharts: GetDeviceChartsResponse;
  getDeviceReport: GetDeviceReportResponse;
  getDeviceReportTotal: GetDeviceReportTotalResponse;
  getDevices: GetDevicesResponse;
  getFiveLeastFrequentlyProcedures?: Maybe<Array<Maybe<ProcedureChart>>>;
  getFiveMostAssistedProcedures?: Maybe<Array<Maybe<MostAssistedProceduresChart>>>;
  getFiveMostFrequentlyProcedures?: Maybe<Array<Maybe<ProcedureChart>>>;
  getGroup?: Maybe<Group>;
  getGroups: GetGroupsResponse;
  getInfrequentProcedures: GetInfrequentProceduresResponse;
  getInstitutionSubscription?: Maybe<InstitutionSubscription>;
  getInstitutions: GetInstitutionsResponse;
  getIntensityTirednessChart: GetIntensityTirednessChartResponse;
  getLearningObjects: GetLearningObjectsResponse;
  getMLData: GetMlDataResponse;
  getMissedDeviceProcedures?: Maybe<GetMissedDeviceProceduresResponse>;
  getMostPopularProcedures: GetMostPopularProceduresResponse;
  getNotAssignedPatients: GetPatientsResponse;
  getNumberOfExecutedProcedures: GetNumberOfExecutedProceduresResponse;
  getNurseAgeExperienceStats: GetNurseAgeExperienceStatsResponse;
  getNurseAgeStats: GetNurseAgeStatsResponse;
  getNurseExperienceStats: GetNurseExperienceStatsResponse;
  getNurseInfoCombined?: Maybe<NurseInfoCombinedResponse>;
  getNurseRoute?: Maybe<NurseRouteResponse>;
  getNursesArrivals?: Maybe<Array<Maybe<NurseArrivalsResponse>>>;
  getNursesExperience: GetNursesExperienceResponse;
  getNursesGenderChart: GetNursesGenderChartResponse;
  getNursesInfoCombined?: Maybe<Array<Maybe<NursesInfoCombinedResponse>>>;
  getNursesLocations?: Maybe<Array<Maybe<NurseLocationsResponse>>>;
  getOftenAssistedProcedures: GetOftenAssistedProceduresResponse;
  getPatient?: Maybe<Patient>;
  getPatientProcedure?: Maybe<GetPatientProcedureResponse>;
  getPatientVisit?: Maybe<PatientVisit>;
  getPatients: GetPatientsResponse;
  getPatientsInShift: Array<Maybe<PatientInShiftType>>;
  getPatientsNotInShift: Array<Maybe<Patient>>;
  getProcedureExecutions?: Maybe<GetProcedureExecutionsResponse>;
  getProcedureFeedbackQuestion?: Maybe<GetProcedureFeedbackQuestionResponse>;
  getProcedureFeedbackQuestions: GetProcedureFeedbackQuestionsResponse;
  getProcedureStepExecutions: GetProcedureStepExecutionsResponse;
  getProcedures: GetProceduresResponse;
  getRateOfFailedAudits?: Maybe<Array<Maybe<GetRateOfFailedAuditsResponse>>>;
  getRoles: GetRolesResponse;
  getRouteMapConfig?: Maybe<RouteMapConfigResponse>;
  getShift?: Maybe<ShiftData>;
  getShiftAverageDurationChart: GetShiftAverageDurationChartResponse;
  getShiftCount: GetShiftCountResponse;
  getShiftIntensityChart: GetShiftIntensityChartResponse;
  getShiftIntensityQuestions: GetShiftIntensityQuestionsResponse;
  getShiftOverviewChart: GetShiftOverviewChartResponse;
  getShiftPatients: GetShiftPatientsResponse;
  getShiftRoute: GetShiftRouteResponse;
  getShiftTiredenessQuestions: GetShiftTiredenessQuestionsResponse;
  getShiftTirednessChart: GetShiftTirednessChartResponse;
  getShiftVisits?: Maybe<Array<Maybe<PatientVisit>>>;
  getShifts: GetShiftsResponse;
  getShiftsWithVisits: GetShiftsWithVisitsResponse;
  getStudies: GetStudiesResponse;
  getSurveyChartData: GetSurveyChartDataResponse;
  getSurveyCharts: GetSurveyChartsResponse;
  getSurveyResults: GetSurveyResultResponse;
  getSurveys: GetSurveysResponse;
  getUpcomingDeviceProcedures?: Maybe<GetUpcomingDeviceProceduresResponse>;
  getUserActivityLog?: Maybe<GetUserActivityLogResponse>;
  getUserPermissionsHistory?: Maybe<GetUserActivityLogResponse>;
  getUserProcedureExperience?: Maybe<GetUserProcedureExperienceResponse>;
  getUserProcedureExperiences?: Maybe<GetUserProcedureExperiencesResponse>;
  getUserProcedureOverview: GetUserProcedureOverviewResponse;
  getUsers: GetUsersResponse;
  getVisitCheckilstByNurseId?: Maybe<Array<VisitChecklist>>;
  getVisitChecklistByShiftId?: Maybe<Array<VisitChecklist>>;
  getVisitChecklistByVisitId?: Maybe<Array<VisitChecklist>>;
  getVisitTypesByDepartmentId?: Maybe<Array<VisitType>>;
  getVisitingNurses?: Maybe<Array<Maybe<VisitingNurse>>>;
  /** @deprecated Use `getVisitsByTimePeriodPaginated` instead. */
  getVisitsByTimePeriod?: Maybe<Array<Maybe<PatientVisit>>>;
  getVisitsByTimePeriodPaginated?: Maybe<GetVisitsByTimePeriodResponse>;
  getVisitsOfNurse?: Maybe<Array<Maybe<PatientVisit>>>;
  getVisitsOfPatient?: Maybe<Array<Maybe<PatientVisit>>>;
  getVisitsOfUser?: Maybe<Array<Maybe<PatientVisit>>>;
  stripePrices: Array<StripePrice>;
};


export type QueryApprovalRequestsArgs = {
  input?: InputMaybe<ApprovalRequestsInput>;
};


export type QueryCurrentUserArgs = {
  input?: InputMaybe<GetCurrentUserInput>;
};


export type QueryGetAcuityArgs = {
  input: GetAcuityInput;
};


export type QueryGetAverageNurseAgeChartArgs = {
  input: GetAverageNurseAgeChartInput;
};


export type QueryGetAveragePatientAcuityDataArgs = {
  input: GetAveragePatientAcuityDataInput;
};


export type QueryGetAverageShiftDataArgs = {
  input: GetAverageShiftDataInput;
};


export type QueryGetAverageTimeSpentOnProcedureArgs = {
  input: GetAverageTimeSpentOnProcedureInput;
};


export type QueryGetAverageTirednessArgs = {
  input: GetAverageTirednessInput;
};


export type QueryGetCategoriesArgs = {
  input: GetCategoriesInput;
};


export type QueryGetChecklistAnswerArgs = {
  input: GetChecklistAnswerInput;
};


export type QueryGetChecklistAnswerByVisitIdArgs = {
  input: GetChecklistAnswerByVisitIdInput;
};


export type QueryGetChecklistPresetArgs = {
  input: GetChecklistPresetInput;
};


export type QueryGetChecklistPresetsByDepartmentIdArgs = {
  input: GetChecklistPresetsByDepartmentIdInput;
};


export type QueryGetChecklistQuestionsArgs = {
  input: GetChecklistQuestionsInput;
};


export type QueryGetConsentArgs = {
  patientId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGetDepartmentsArgs = {
  input: GetDepartmentsInput;
};


export type QueryGetDeviceArgs = {
  input: GetDeviceInput;
};


export type QueryGetDeviceChartsArgs = {
  input?: InputMaybe<GetDeviceChartsInput>;
};


export type QueryGetDeviceReportArgs = {
  input?: InputMaybe<GetDeviceReportInput>;
};


export type QueryGetDeviceReportTotalArgs = {
  input?: InputMaybe<GetDeviceReportTotalInput>;
};


export type QueryGetDevicesArgs = {
  input: GetDevicesInput;
};


export type QueryGetFiveLeastFrequentlyProceduresArgs = {
  input: GetFiveLeastFrequentlyProceduresInput;
};


export type QueryGetFiveMostAssistedProceduresArgs = {
  input: GetFiveMostAssistedProceduresInput;
};


export type QueryGetFiveMostFrequentlyProceduresArgs = {
  input: GetFiveMostFrequentlyProceduresInput;
};


export type QueryGetGroupArgs = {
  input: GetGroupInput;
};


export type QueryGetGroupsArgs = {
  input: GetGroupsInput;
};


export type QueryGetInfrequentProceduresArgs = {
  input: GetInfrequentProceduresInput;
};


export type QueryGetInstitutionsArgs = {
  input: GetInstitutionsInput;
};


export type QueryGetIntensityTirednessChartArgs = {
  input: GetIntensityTirednessChartInput;
};


export type QueryGetLearningObjectsArgs = {
  input: GetLearningObjectsInput;
};


export type QueryGetMlDataArgs = {
  input: GetMlDataInput;
};


export type QueryGetMissedDeviceProceduresArgs = {
  input: GetMissedDeviceProceduresInput;
};


export type QueryGetMostPopularProceduresArgs = {
  input: GetMostPopularProceduresInput;
};


export type QueryGetNumberOfExecutedProceduresArgs = {
  input: GetNumberOfExecutedProceduresInput;
};


export type QueryGetNurseAgeExperienceStatsArgs = {
  input: GetNurseAgeExperienceStatsInput;
};


export type QueryGetNurseAgeStatsArgs = {
  input: GetNurseAgeStatsInput;
};


export type QueryGetNurseExperienceStatsArgs = {
  input: GetNurseExperienceStatsInput;
};


export type QueryGetNurseInfoCombinedArgs = {
  input?: InputMaybe<NurseInfoCombinedInput>;
};


export type QueryGetNurseRouteArgs = {
  input: NurseRouteInput;
};


export type QueryGetNursesArrivalsArgs = {
  input?: InputMaybe<NurseArrivalsInput>;
};


export type QueryGetNursesExperienceArgs = {
  input: GetNursesExperienceInput;
};


export type QueryGetNursesGenderChartArgs = {
  input: GetNursesGenderChartInput;
};


export type QueryGetNursesInfoCombinedArgs = {
  input?: InputMaybe<NursesInfoCombinedInput>;
};


export type QueryGetNursesLocationsArgs = {
  input?: InputMaybe<NurseLocationsInput>;
};


export type QueryGetPatientArgs = {
  input: GetPatientInput;
};


export type QueryGetPatientProcedureArgs = {
  input?: InputMaybe<GetPatientProcedureInput>;
};


export type QueryGetPatientVisitArgs = {
  input?: InputMaybe<GetPatientVisitInput>;
};


export type QueryGetPatientsArgs = {
  input: GetPatientsInput;
};


export type QueryGetProcedureExecutionsArgs = {
  input: GetProcedureExecutionsInput;
};


export type QueryGetProcedureFeedbackQuestionArgs = {
  input: GetProcedureFeedbackQuestionInput;
};


export type QueryGetProcedureFeedbackQuestionsArgs = {
  input: GetProcedureFeedbackQuestionsInput;
};


export type QueryGetProcedureStepExecutionsArgs = {
  input: GetProcedureStepExecutionsInput;
};


export type QueryGetProceduresArgs = {
  input: GetProceduresInput;
};


export type QueryGetRateOfFailedAuditsArgs = {
  input?: InputMaybe<GetRateOfFailedAuditsInput>;
};


export type QueryGetRolesArgs = {
  input: GetRolesInput;
};


export type QueryGetRouteMapConfigArgs = {
  institutionUuid: Scalars['UUID']['input'];
};


export type QueryGetShiftArgs = {
  input: GetShiftInput;
};


export type QueryGetShiftAverageDurationChartArgs = {
  input: GetShiftAverageDurationChartInput;
};


export type QueryGetShiftCountArgs = {
  input: GetShiftCountInput;
};


export type QueryGetShiftIntensityChartArgs = {
  input: GetShiftIntensityChartInput;
};


export type QueryGetShiftIntensityQuestionsArgs = {
  input: GetShiftIntensityQuestionsInput;
};


export type QueryGetShiftOverviewChartArgs = {
  input: GetShiftOverviewChartInput;
};


export type QueryGetShiftPatientsArgs = {
  input: GetShiftPatientsInput;
};


export type QueryGetShiftRouteArgs = {
  input: GetShiftRouteInput;
};


export type QueryGetShiftTiredenessQuestionsArgs = {
  input: GetShiftTiredenessQuestionsInput;
};


export type QueryGetShiftTirednessChartArgs = {
  input: GetShiftTirednessChartInput;
};


export type QueryGetShiftVisitsArgs = {
  input?: InputMaybe<GetShiftVisitsInput>;
};


export type QueryGetShiftsArgs = {
  input: GetShiftsInput;
};


export type QueryGetShiftsWithVisitsArgs = {
  input: GetShiftsWithVisitsInput;
};


export type QueryGetStudiesArgs = {
  input: GetStudiesInput;
};


export type QueryGetSurveyChartDataArgs = {
  input: GetSurveyChartDataInput;
};


export type QueryGetSurveyChartsArgs = {
  input: GetSurveyChartsInput;
};


export type QueryGetSurveyResultsArgs = {
  input: GetSurveyResultInput;
};


export type QueryGetSurveysArgs = {
  input: GetSurveysInput;
};


export type QueryGetUpcomingDeviceProceduresArgs = {
  input: GetUpcomingDeviceProceduresInput;
};


export type QueryGetUserActivityLogArgs = {
  input: GetUserActivityLogInput;
};


export type QueryGetUserPermissionsHistoryArgs = {
  input: GetUserActivityLogInput;
};


export type QueryGetUserProcedureExperienceArgs = {
  input: GetUserProcedureExperienceInput;
};


export type QueryGetUserProcedureOverviewArgs = {
  input: GetUserProcedureOverviewInput;
};


export type QueryGetUsersArgs = {
  input: GetUsersInput;
};


export type QueryGetVisitCheckilstByNurseIdArgs = {
  nurseUuid: Scalars['UUID']['input'];
};


export type QueryGetVisitChecklistByShiftIdArgs = {
  shiftUuid: Scalars['UUID']['input'];
};


export type QueryGetVisitChecklistByVisitIdArgs = {
  visitUuid: Scalars['UUID']['input'];
};


export type QueryGetVisitTypesByDepartmentIdArgs = {
  departmentUuid: Scalars['UUID']['input'];
};


export type QueryGetVisitsByTimePeriodArgs = {
  input?: InputMaybe<GetVisitsByTimePeriodInput>;
};


export type QueryGetVisitsByTimePeriodPaginatedArgs = {
  input?: InputMaybe<GetVisitsByTimePeriodInput>;
};


export type QueryGetVisitsOfNurseArgs = {
  input?: InputMaybe<GetVisitsOfNurseInput>;
};


export type QueryGetVisitsOfPatientArgs = {
  input?: InputMaybe<GetVisitsOfPatientInput>;
};


export type QueryGetVisitsOfUserArgs = {
  input?: InputMaybe<GetVisitsOfUserInput>;
};

export type Question = {
  __typename?: 'Question';
  answer?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  department?: Maybe<Department>;
  details?: Maybe<QuestionDetails>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<StudyPermission>;
  position?: Maybe<Scalars['Int']['output']>;
  question: Scalars['String']['output'];
  type: QuestionType;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export type QuestionDetails = ChoiceQuestion | CognitionQuestion | FreeTextQuestion | MediaQuestion | MultiChoiceQuestion | ScaleQuestion;

export type QuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  type: QuestionType;
};

export enum QuestionType {
  Boolean = 'BOOLEAN',
  Choice = 'CHOICE',
  Cognition = 'COGNITION',
  Date = 'DATE',
  FreeText = 'FREE_TEXT',
  Media = 'MEDIA',
  MultipleChoice = 'MULTIPLE_CHOICE',
  MultiChoice = 'MULTI_CHOICE',
  Number = 'NUMBER',
  Scale = 'SCALE',
  Text = 'TEXT'
}

export type ReInviteUserInput = {
  departmentId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  institutionId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  userId?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type ReInviteUserResponse = {
  __typename?: 'ReInviteUserResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type ResetUserPasswordInput = {
  id: Scalars['UUID']['input'];
};

export type ResetUserPasswordResponse = {
  __typename?: 'ResetUserPasswordResponse';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RevokeUserRoleInput = {
  approvalId?: InputMaybe<Scalars['ID']['input']>;
  roleId: Scalars['UUID']['input'];
};

export type RevokeUserRoleResponse = {
  __typename?: 'RevokeUserRoleResponse';
  approvalRequest?: Maybe<ApprovalRequest>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Role = {
  __typename?: 'Role';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['UUID']['output'];
  createdByType: ActorType;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export type RouteMapConfigResponse = {
  __typename?: 'RouteMapConfigResponse';
  historyAvailableFrom: Scalars['DateTime']['output'];
  retentionMonths: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
};

export type ScaleAnswer = {
  __typename?: 'ScaleAnswer';
  meaning?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ScaleOptionValue = {
  __typename?: 'ScaleOptionValue';
  meaning?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type ScaleQuestion = {
  __typename?: 'ScaleQuestion';
  optionValues?: Maybe<Array<Maybe<ScaleOptionValue>>>;
  question?: Maybe<Scalars['String']['output']>;
  selectedValue?: Maybe<Scalars['Int']['output']>;
};

export type SearchInput = {
  field: Array<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type SexStats = {
  __typename?: 'SexStats';
  gender?: Maybe<Scalars['String']['output']>;
  monthOfBirth?: Maybe<Scalars['Int']['output']>;
};

export type Shift = {
  __typename?: 'Shift';
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  shiftDataUuid: Scalars['UUID']['output'];
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userUuid: Scalars['UUID']['output'];
};

export type ShiftData = {
  __typename?: 'ShiftData';
  dayShift?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  intensityScore?: Maybe<Scalars['Int']['output']>;
  intensitySurveyResult?: Maybe<Array<Maybe<IntensitySurveyResultItem>>>;
  nrOfPatients?: Maybe<Scalars['Int']['output']>;
  patient?: Maybe<Array<Maybe<Patient>>>;
  shiftDataUuid?: Maybe<Scalars['UUID']['output']>;
  shiftUuid?: Maybe<Scalars['UUID']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tiredenessSurveyResult?: Maybe<Array<Maybe<TiredenessSurveyResultItem>>>;
  totalPatientAcuity?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
  visits?: Maybe<Array<Maybe<PatientVisit>>>;
};

export type ShiftIntensityQuestion = {
  __typename?: 'ShiftIntensityQuestion';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShiftPatient = {
  __typename?: 'ShiftPatient';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  shiftUuid?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShiftTiredenessQuestion = {
  __typename?: 'ShiftTiredenessQuestion';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShiftWithVisits = {
  __typename?: 'ShiftWithVisits';
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  shiftDataUuid: Scalars['UUID']['output'];
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userUuid: Scalars['UUID']['output'];
  visits?: Maybe<Array<Maybe<PatientVisit>>>;
};

export enum Signer {
  Patient = 'Patient',
  PatientRepresentative = 'PatientRepresentative'
}

export type SignupUserInput = {
  dateOfBirth: Scalars['DateTime']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirm: Scalars['String']['input'];
  signupToken: Scalars['String']['input'];
  startWorkAt: Scalars['DateTime']['input'];
  startedPractising?: InputMaybe<Scalars['Date']['input']>;
};

export type SignupUserResponse = {
  __typename?: 'SignupUserResponse';
  profile?: Maybe<User>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
};

export type SignupUserStartTrialInput = {
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  passwordConfirm: Scalars['String']['input'];
  signupToken: Scalars['String']['input'];
  startedPractising?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SignupUserStartTrialPayload = {
  __typename?: 'SignupUserStartTrialPayload';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type SortByInput = {
  sort?: InputMaybe<OrderDirection>;
};

export type StepError = {
  __typename?: 'StepError';
  error?: Maybe<Scalars['String']['output']>;
  stepName?: Maybe<Scalars['String']['output']>;
};

export type StepExitDecision = {
  __typename?: 'StepExitDecision';
  value?: Maybe<Scalars['String']['output']>;
};

export type StepExitMeasurement = {
  __typename?: 'StepExitMeasurement';
  valueMax?: Maybe<Scalars['Float']['output']>;
  valueMin?: Maybe<Scalars['Float']['output']>;
};

export type StripePlan = {
  __typename?: 'StripePlan';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
};

export type StripePrice = {
  __typename?: 'StripePrice';
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lookup_key?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  product?: Maybe<StripeProduct>;
  recurring?: Maybe<StripeRecurring>;
  tiers?: Maybe<Array<Maybe<StripeTier>>>;
  tiers_mode?: Maybe<Scalars['String']['output']>;
  unit_amount?: Maybe<Scalars['Int']['output']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  active?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type StripeRecurring = {
  __typename?: 'StripeRecurring';
  interval?: Maybe<Scalars['String']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
};

export type StripeTier = {
  __typename?: 'StripeTier';
  flat_amount?: Maybe<Scalars['Int']['output']>;
  unit_amount?: Maybe<Scalars['Int']['output']>;
  up_to?: Maybe<Scalars['Int']['output']>;
};

export type Study = {
  __typename?: 'Study';
  author?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['UUID']['output']>;
  department?: Maybe<Department>;
  description?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  permission?: Maybe<StudyPermission>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<StudyStatus>;
  survey?: Maybe<Array<Maybe<Survey>>>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};


export type StudySurveyArgs = {
  input?: InputMaybe<GetSurveysInput>;
};

export enum StudyPermission {
  Department = 'DEPARTMENT',
  Institution = 'INSTITUTION',
  Public = 'PUBLIC'
}

export enum StudyStatus {
  Finished = 'FINISHED',
  Ongoing = 'ONGOING',
  Pending = 'PENDING'
}

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  GraceExpired = 'GRACE_EXPIRED',
  GracePeriod = 'GRACE_PERIOD',
  TrialActive = 'TRIAL_ACTIVE',
  TrialExpired = 'TRIAL_EXPIRED'
}

export type Survey = {
  __typename?: 'Survey';
  author?: Maybe<User>;
  category?: Maybe<Array<Maybe<Category>>>;
  childSurvey?: Maybe<Array<Maybe<Survey>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  description?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  hasGate?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  mlFeatureType?: Maybe<MlSurveyTypeEnum>;
  name?: Maybe<Scalars['String']['output']>;
  oldId?: Maybe<Scalars['String']['output']>;
  overallScore?: Maybe<Scalars['Boolean']['output']>;
  parentSurvey?: Maybe<Survey>;
  position?: Maybe<Scalars['Int']['output']>;
  questions?: Maybe<Array<Maybe<Question>>>;
  results?: Maybe<Array<Maybe<SurveyResult>>>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SurveyStatus>;
  study?: Maybe<Study>;
  surveyType?: Maybe<SurveyType>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};


export type SurveyQuestionsArgs = {
  input?: InputMaybe<GetQuestionInput>;
};


export type SurveyResultsArgs = {
  input?: InputMaybe<GetSurveyResultInput>;
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  id: Scalars['UUID']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  questionId: Scalars['UUID']['output'];
  surveyId: Scalars['UUID']['output'];
};

export type SurveyResult = {
  __typename?: 'SurveyResult';
  answers?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  survey?: Maybe<Survey>;
  user?: Maybe<User>;
};

export type SurveyResultAnswer = {
  avgReactionMS?: InputMaybe<Scalars['Float']['input']>;
  correctScore?: InputMaybe<Scalars['Float']['input']>;
  incorrectScore?: InputMaybe<Scalars['Float']['input']>;
  meaning?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  questionId: Scalars['UUID']['input'];
  questionType: QuestionType;
  selectedAnser?: InputMaybe<Scalars['String']['input']>;
};

export enum SurveyStatus {
  Finished = 'FINISHED',
  Ongoing = 'ONGOING',
  Pending = 'PENDING'
}

export enum SurveyType {
  AssessmentPeriod = 'ASSESSMENT_PERIOD',
  Mixed = 'MIXED',
  None = 'NONE',
  SurveyPeriod = 'SURVEY_PERIOD'
}

export type TiredenessSurveyResultInputItem = {
  answer: Scalars['Int']['input'];
  questionID: Scalars['UUID']['input'];
};

export type TiredenessSurveyResultItem = {
  __typename?: 'TiredenessSurveyResultItem';
  answer: Scalars['Int']['output'];
  questionID: Scalars['UUID']['output'];
};

export type TirednessIntensityStats = {
  __typename?: 'TirednessIntensityStats';
  date?: Maybe<Scalars['String']['output']>;
  intensityAverage?: Maybe<Scalars['Float']['output']>;
  shiftCount?: Maybe<Scalars['Int']['output']>;
  tirednessAverage?: Maybe<Scalars['Float']['output']>;
};

export type TotalRecordsType = {
  __typename?: 'TotalRecordsType';
  totalNumberOfExecutedProcedures?: Maybe<Scalars['Int']['output']>;
  totalNumberOfFailedAudits?: Maybe<Scalars['Int']['output']>;
  totalNumberOfFinishedProcedures?: Maybe<Scalars['Int']['output']>;
  totalNumberOfStoppedProcedures?: Maybe<Scalars['Int']['output']>;
  totalNumberOfSuccessfullAudits?: Maybe<Scalars['Int']['output']>;
};

export type UwesChartData = {
  __typename?: 'UWESChartData';
  ABSORPTION?: Maybe<Scalars['Float']['output']>;
  DEDICATION?: Maybe<Scalars['Float']['output']>;
  ENGAGEMENT?: Maybe<Scalars['Float']['output']>;
  VIGOR?: Maybe<Scalars['Float']['output']>;
};

export type UpcomingDeviceProcedureItem = {
  __typename?: 'UpcomingDeviceProcedureItem';
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceUuid?: Maybe<Scalars['UUID']['output']>;
  lastExecution?: Maybe<Scalars['DateTime']['output']>;
  nextExecution?: Maybe<Scalars['DateTime']['output']>;
  procedureName?: Maybe<Scalars['String']['output']>;
  procedureUuid?: Maybe<Scalars['UUID']['output']>;
};

export type UpdateAcuityInput = {
  data: Acuity;
  id: Scalars['UUID']['input'];
};

export type UpdateAcuityResponse = {
  __typename?: 'UpdateAcuityResponse';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type UpdateCategoryDataType = {
  categoryType?: InputMaybe<CategoryType>;
  description?: InputMaybe<Scalars['String']['input']>;
  institutionUuid?: InputMaybe<Scalars['UUID']['input']>;
  mlFeatureSubtype?: InputMaybe<MlFeatureSubtypeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  surveyUuid?: InputMaybe<Scalars['UUID']['input']>;
  updateByType?: InputMaybe<ActorType>;
};

export type UpdateCategoryInput = {
  data: UpdateCategoryDataType;
  id: Scalars['UUID']['input'];
};

export type UpdateCategoryResponse = {
  __typename?: 'UpdateCategoryResponse';
  categoryType?: Maybe<CategoryType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  description?: Maybe<Scalars['String']['output']>;
  institution?: Maybe<Institution>;
  mlFeatureSubtype?: Maybe<MlFeatureSubtypeEnum>;
  mlFeatureType?: Maybe<MlFeatureTypeEnum>;
  name?: Maybe<Scalars['String']['output']>;
  surveyUuid?: Maybe<Scalars['UUID']['output']>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export type UpdateChecklistAnswerInput = {
  checklistUuid?: InputMaybe<Scalars['UUID']['input']>;
  results?: InputMaybe<Array<InputMaybe<AnswerResultInput>>>;
  userUuid?: InputMaybe<Scalars['UUID']['input']>;
  uuid: Scalars['UUID']['input'];
  visitUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateChecklistPresetInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  departmentUuid?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['UUID']['input'];
};

export type UpdateChecklistQuestionInput = {
  checklistUuid?: InputMaybe<Scalars['UUID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['UUID']['input'];
};

export type UpdateData = {
  auditFrequency?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  institutionId?: InputMaybe<Scalars['UUID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lifeCycleNum?: InputMaybe<Scalars['Int']['input']>;
  lifeCycleTime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  procedures?: InputMaybe<Scalars['UUID']['input']>;
  userManuals?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateDataInput = {
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  modelOutput?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientAcuity?: InputMaybe<Scalars['Int']['input']>;
  patientUuid?: InputMaybe<Scalars['UUID']['input']>;
  procedureUuid?: InputMaybe<Scalars['UUID']['input']>;
  reasonForTermination?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<Scalars['Int']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<ProcedureExecutionStateEnum>;
  terminationComment?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateDepartmentInput = {
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateDepartmentResponse = {
  __typename?: 'UpdateDepartmentResponse';
  code?: Maybe<Scalars['String']['output']>;
  department: Department;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type UpdateDeviceInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  udi?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeviceProcedureExecutionInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  deviceUuid?: InputMaybe<Scalars['UUID']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  groupProcedureUuid?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateDeviceProcedureExecutionResponse = {
  __typename?: 'UpdateDeviceProcedureExecutionResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type UpdateDeviceProcedureExecutionStatusInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['UUID']['input'];
  status: DeviceProcedureExecutionStatusEnum;
};

export type UpdateDeviceProcedureExecutionStatusResponse = {
  __typename?: 'UpdateDeviceProcedureExecutionStatusResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type UpdateGroupInput = {
  data: UpdateData;
  id: Scalars['UUID']['input'];
};

export type UpdateInstitutionInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  cvi?: InputMaybe<Scalars['JSONObject']['input']>;
  house?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  stopDetectionDuration?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInstitutionResponse = {
  __typename?: 'UpdateInstitutionResponse';
  code?: Maybe<Scalars['String']['output']>;
  institution?: Maybe<Institution>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearningObjectInput = {
  author?: InputMaybe<Scalars['UUID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<LearningObjectPermission>;
};

export type UpdateLearningObjectResponse = {
  __typename?: 'UpdateLearningObjectResponse';
  code?: Maybe<Scalars['String']['output']>;
  learningObject: LearningObject;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type UpdatePatientInput = {
  data?: InputMaybe<PatientDataUpdate>;
  patientUuid: Scalars['ID']['input'];
};

export type UpdatePatientProcedureInput = {
  data?: InputMaybe<PatientProcedureItem>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdatePatientProcedureResponse = {
  __typename?: 'UpdatePatientProcedureResponse';
  end?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  procedureUuid?: Maybe<Scalars['UUID']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type UpdatePatientResponse = {
  __typename?: 'UpdatePatientResponse';
  address?: Maybe<Scalars['String']['output']>;
  admissionDate?: Maybe<Scalars['Date']['output']>;
  allergy?: Maybe<Array<Maybe<AllergyType>>>;
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<Scalars['UUID']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  deletedBy?: Maybe<Scalars['UUID']['output']>;
  departmentUuid?: Maybe<Scalars['UUID']['output']>;
  dischargeDate?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<PatientGender>;
  house?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  identification?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  medication?: Maybe<Array<Maybe<MedicationType>>>;
  name?: Maybe<Scalars['String']['output']>;
  nurseUuid?: Maybe<Scalars['UUID']['output']>;
  patientType?: Maybe<PatientTypeEnum>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primaryDiagnosis?: Maybe<Scalars['String']['output']>;
  secondaryDiagnosis?: Maybe<Scalars['String']['output']>;
  shiftUuid?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updateAt?: Maybe<Scalars['Date']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<Scalars['UUID']['output']>;
};

export type UpdatePatientVisitInput = {
  data?: InputMaybe<PatientVisitItem>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdatePatientVisitResponse = {
  __typename?: 'UpdatePatientVisitResponse';
  end?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<VisitStatusEnum>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type UpdateProcedureInput = {
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  checklist?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProcedureStatus>;
  steps?: InputMaybe<Array<InputMaybe<ProcedureStepInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProcedureStepExecutionInput = {
  data: ProcedureStepExecutionUpdateItem;
  id: Scalars['UUID']['input'];
};

export type UpdateProcedureStepExecutionResponse = {
  __typename?: 'UpdateProcedureStepExecutionResponse';
  duration?: Maybe<Scalars['Int']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  parentStepUuid?: Maybe<Scalars['UUID']['output']>;
  procedureExecutionUuid?: Maybe<Scalars['UUID']['output']>;
  procedureStepUuid?: Maybe<Scalars['UUID']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<ProcedureStepExecutionState>;
  stepExitUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<ProcedureStepExecutionType>;
};

export type UpdateQuestionInput = {
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  details?: InputMaybe<Scalars['JSONObject']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['UUID']['input'];
  type?: InputMaybe<QuestionType>;
};

export type UpdateQuestionPositionInput = {
  newPosition: Scalars['Int']['input'];
  questionId: Scalars['UUID']['input'];
  surveyId: Scalars['UUID']['input'];
};

export type UpdateQuestionPositionResponse = {
  __typename?: 'UpdateQuestionPositionResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  surveyQuestion: SurveyQuestion;
};

export type UpdateQuestionResponse = {
  __typename?: 'UpdateQuestionResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Question>;
  status: Scalars['Boolean']['output'];
};

export type UpdateShiftEndTimeInput = {
  endTime: Scalars['DateTime']['input'];
  shiftUuid: Scalars['UUID']['input'];
};

export type UpdateShiftEndTimeResponse = {
  __typename?: 'UpdateShiftEndTimeResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type UpdateStudyInput = {
  departmentId: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  institutionId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  permission?: InputMaybe<StudyPermission>;
};

export type UpdateStudyResponse = {
  __typename?: 'UpdateStudyResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  study: Study;
};

export type UpdateSurveyInput = {
  description: Scalars['String']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasGate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  overallScore?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateSurveyPositionInput = {
  newPosition?: InputMaybe<Scalars['Int']['input']>;
  surveyId: Scalars['UUID']['input'];
};

export type UpdateSurveyPositionResponse = {
  __typename?: 'UpdateSurveyPositionResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  survey: Survey;
};

export type UpdateSurveyResponse = {
  __typename?: 'UpdateSurveyResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  survey: Survey;
};

export type UpdateUserInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  retired?: InputMaybe<Scalars['Date']['input']>;
  startedPractising?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  user: User;
};

export type UpdateVisitChecklistInput = {
  anamnesis?: InputMaybe<Scalars['String']['input']>;
  applied_medicinal_treatment?: InputMaybe<Scalars['String']['input']>;
  applied_treatment?: InputMaybe<Scalars['String']['input']>;
  blood_pressure_diastolic?: InputMaybe<Scalars['Int']['input']>;
  blood_pressure_systolic?: InputMaybe<Scalars['Int']['input']>;
  complaint_data?: InputMaybe<Scalars['String']['input']>;
  condition_assessment?: InputMaybe<Scalars['String']['input']>;
  consultation_plans?: InputMaybe<Scalars['String']['input']>;
  diagnoses?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  instrumental_tests?: InputMaybe<Scalars['String']['input']>;
  laboratory_tests?: InputMaybe<Scalars['String']['input']>;
  patient_status: Scalars['String']['input'];
  pulse?: InputMaybe<Scalars['Int']['input']>;
  questions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  recommendations?: InputMaybe<Scalars['String']['input']>;
  specialist?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['UUID']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateVisitTypeInput = {
  type?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type User = {
  __typename?: 'User';
  active?: Maybe<Scalars['Boolean']['output']>;
  activeShift?: Maybe<Array<Maybe<ShiftData>>>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByType?: Maybe<ActorType>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  departments?: Maybe<Array<Maybe<Department>>>;
  deviceProcedureExecutions?: Maybe<Array<Maybe<DeviceProcedureExecution>>>;
  disabledSubByAdmin?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars['UUID']['output']>;
  institution?: Maybe<Institution>;
  language?: Maybe<Scalars['String']['output']>;
  missedProcedures?: Maybe<Array<Maybe<ProcedureExecutionItemType>>>;
  name?: Maybe<Scalars['String']['output']>;
  passwordResetInit?: Maybe<Scalars['DateTime']['output']>;
  patients?: Maybe<Array<Maybe<Patient>>>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
  scheduledProcedures?: Maybe<Array<Maybe<ProcedureExecutionItemType>>>;
  shift?: Maybe<Array<Maybe<ShiftData>>>;
  startedPractising?: Maybe<Scalars['Date']['output']>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
};

export type UserDepartmentRole = {
  __typename?: 'UserDepartmentRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['UUID']['output'];
  createdByType: ActorType;
  createdByUser?: Maybe<User>;
  department?: Maybe<Department>;
  departmentUuid: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  role?: Maybe<Role>;
  roleUuid: Scalars['UUID']['output'];
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updateBy?: Maybe<Scalars['UUID']['output']>;
  updateByType?: Maybe<ActorType>;
  user?: Maybe<User>;
  userUuid: Scalars['UUID']['output'];
};

export type UserProcedureExperience = {
  __typename?: 'UserProcedureExperience';
  confidenceScore?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  procedureUuid?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  departmentId?: Maybe<Scalars['UUID']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  institutionId?: Maybe<Scalars['UUID']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  role: Scalars['String']['output'];
  roleName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
  userRoleId?: Maybe<Scalars['UUID']['output']>;
};

export type VisitChecklist = {
  __typename?: 'VisitChecklist';
  anamnesis?: Maybe<Scalars['String']['output']>;
  applied_medicinal_treatment?: Maybe<Scalars['String']['output']>;
  applied_treatment?: Maybe<Scalars['String']['output']>;
  blood_pressure_diastolic?: Maybe<Scalars['Int']['output']>;
  blood_pressure_systolic?: Maybe<Scalars['Int']['output']>;
  complaint_data?: Maybe<Scalars['String']['output']>;
  condition_assessment?: Maybe<Scalars['String']['output']>;
  consultation_plans?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  diagnoses?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  instrumental_tests?: Maybe<Scalars['String']['output']>;
  laboratory_tests?: Maybe<Scalars['String']['output']>;
  patient_status: Scalars['String']['output'];
  pulse?: Maybe<Scalars['Int']['output']>;
  questions?: Maybe<Array<Maybe<Question>>>;
  recommendations?: Maybe<Scalars['String']['output']>;
  specialist?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  visit_uuid?: Maybe<Scalars['UUID']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export enum VisitStatusEnum {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Scheduled = 'SCHEDULED',
  Started = 'STARTED'
}

export type VisitType = {
  __typename?: 'VisitType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  departmentUuid?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type VisitingNurse = {
  __typename?: 'VisitingNurse';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  socketId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AddPatientToUserInput = {
  patientId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type AddPatientToUserResponse = {
  __typename?: 'addPatientToUserResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type AddShiftPatientInput = {
  id: Scalars['UUID']['input'];
  patientIds: Array<InputMaybe<Scalars['UUID']['input']>>;
};

export type CreateProcedureExecutionInput = {
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  modelOutput?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientAcuity?: InputMaybe<Scalars['Int']['input']>;
  patientUuid?: InputMaybe<Scalars['UUID']['input']>;
  procedureUuid?: InputMaybe<Scalars['UUID']['input']>;
  reasonForTermination?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<Scalars['Int']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<ProcedureExecutionStateEnum>;
  terminationComment?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateProcedureExecutionResponse = {
  __typename?: 'createProcedureExecutionResponse';
  duration?: Maybe<Scalars['Int']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  modelOutput?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientAcuity?: Maybe<Scalars['Int']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  procedureUuid?: Maybe<Scalars['UUID']['output']>;
  reasonForTermination?: Maybe<Scalars['String']['output']>;
  scheduled?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<ProcedureExecutionStateEnum>;
  terminationComment?: Maybe<Scalars['String']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type CreateProcedureFeedbackAnswerResponse = {
  __typename?: 'createProcedureFeedbackAnswerResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateShiftInput = {
  duration: Scalars['Int']['input'];
  intensity_score?: InputMaybe<Scalars['Int']['input']>;
  intensity_survey_result?: InputMaybe<Array<InputMaybe<IntensitySurveyResultInputItem>>>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  start_time: Scalars['DateTime']['input'];
  tiredeness_survey_result?: InputMaybe<Array<InputMaybe<TiredenessSurveyResultInputItem>>>;
};

export type CreateShiftResponse = {
  __typename?: 'createShiftResponse';
  shift_data_uuid?: Maybe<Scalars['UUID']['output']>;
  user_uuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type CreateUserProcedureExperienceInput = {
  confidenceScore: Scalars['Int']['input'];
  procedureId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type CreateUserProcedureExperienceResponse = {
  __typename?: 'createUserProcedureExperienceResponse';
  id?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DeletePatientFromUserInput = {
  patientId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type DeletePatientFromUserResponse = {
  __typename?: 'deletePatientFromUserResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteProcedureExecutionInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteProcedureExecutionResponse = {
  __typename?: 'deleteProcedureExecutionResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteShiftInput = {
  shiftUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteShiftPatientInput = {
  id: Scalars['UUID']['input'];
  patientIds: Array<InputMaybe<Scalars['UUID']['input']>>;
};

export type DeleteShiftResponse = {
  __typename?: 'deleteShiftResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type GetNurseAgeExperienceStatsResponse = {
  __typename?: 'getNurseAgeExperienceStatsResponse';
  stats?: Maybe<Array<Maybe<AgeExperienceStats>>>;
};

export type GetNurseAgeStatsResponse = {
  __typename?: 'getNurseAgeStatsResponse';
  stats?: Maybe<Array<Maybe<AgeStats>>>;
};

export type GetNurseExperienceStatsInput = {
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId: Scalars['UUID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetNurseExperienceStatsResponse = {
  __typename?: 'getNurseExperienceStatsResponse';
  stats?: Maybe<Array<Maybe<SexStats>>>;
};

export type GetNursesExperienceResponse = {
  __typename?: 'getNursesExperienceResponse';
  count?: Maybe<Scalars['Int']['output']>;
  fromFiveToTen?: Maybe<Scalars['Int']['output']>;
  fromOneToFive?: Maybe<Scalars['Int']['output']>;
  lessThanOne?: Maybe<Scalars['Int']['output']>;
  moreThanTen?: Maybe<Scalars['Int']['output']>;
};

export type GetProcedureExecutionsInput = {
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetProcedureExecutionsResponse = {
  __typename?: 'getProcedureExecutionsResponse';
  items?: Maybe<Array<Maybe<ProcedureExecutionItemType>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetShiftInput = {
  uuid: Scalars['ID']['input'];
};

export type GetShiftsInput = {
  dateTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  pager?: InputMaybe<PagerInput>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetShiftsResponse = {
  __typename?: 'getShiftsResponse';
  items?: Maybe<Array<Maybe<Shift>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetShiftsWithVisitsInput = {
  dateTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  pager?: InputMaybe<PagerInput>;
  patientUuid?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
};

export type GetShiftsWithVisitsResponse = {
  __typename?: 'getShiftsWithVisitsResponse';
  items?: Maybe<Array<Maybe<ShiftWithVisits>>>;
  pager?: Maybe<PagerResponse>;
};

export type GetUserProcedureExperienceInput = {
  procedureId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type GetUserProcedureExperienceResponse = {
  __typename?: 'getUserProcedureExperienceResponse';
  confidenceScore?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  procedureUuid?: Maybe<Scalars['UUID']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type GetUserProcedureExperiencesResponse = {
  __typename?: 'getUserProcedureExperiencesResponse';
  items?: Maybe<Array<Maybe<UserProcedureExperience>>>;
};

export type MovePatientFromShiftInput = {
  fromShiftId: Scalars['UUID']['input'];
  patientId: Scalars['UUID']['input'];
  toShiftId: Scalars['UUID']['input'];
};

export type MovePatientFromShiftResponse = {
  __typename?: 'movePatientFromShiftResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['String']['output']>;
};

export type MovePatientToUserInput = {
  fromUserId: Scalars['UUID']['input'];
  patientId: Scalars['UUID']['input'];
  toUserId: Scalars['UUID']['input'];
};

export type MovePatientToUserResponse = {
  __typename?: 'movePatientToUserResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type NumberOfProceduresType = {
  __typename?: 'numberOfProceduresType';
  numberOfExecutedProcedures?: Maybe<Scalars['Int']['output']>;
  numberOfFailedAudits?: Maybe<Scalars['Int']['output']>;
  numberOfFinishedProcedures?: Maybe<Scalars['Int']['output']>;
  numberOfStoppedProcedures?: Maybe<Scalars['Int']['output']>;
  numberOfSuccessfullAudits?: Maybe<Scalars['Int']['output']>;
};

export type ShiftDataUpdate = {
  duration?: InputMaybe<Scalars['Time']['input']>;
  intensity_score?: InputMaybe<Scalars['Int']['input']>;
  intensity_survey_result?: InputMaybe<Array<InputMaybe<IntensitySurveyResultInputItem>>>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  tiredeness_survey_result?: InputMaybe<Array<InputMaybe<TiredenessSurveyResultInputItem>>>;
};

export type StatInput = {
  department?: InputMaybe<Scalars['UUID']['input']>;
  departmentId?: InputMaybe<Scalars['UUID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  institution?: InputMaybe<Scalars['UUID']['input']>;
  institutionId: Scalars['UUID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateProcedureExecutionInput = {
  data: UpdateDataInput;
  id: Scalars['UUID']['input'];
};

export type UpdateProcedureExecutionResponse = {
  __typename?: 'updateProcedureExecutionResponse';
  duration?: Maybe<Scalars['Int']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  modelOutput?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientAcuity?: Maybe<Scalars['Int']['output']>;
  patientUuid?: Maybe<Scalars['UUID']['output']>;
  procedureUuid?: Maybe<Scalars['UUID']['output']>;
  reasonForTermination?: Maybe<Scalars['String']['output']>;
  scheduled?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<ProcedureExecutionStateEnum>;
  terminationComment?: Maybe<Scalars['String']['output']>;
  userUuid?: Maybe<Scalars['UUID']['output']>;
};

export type UpdateShiftInput = {
  data?: InputMaybe<ShiftDataUpdate>;
  shiftUuid: Scalars['ID']['input'];
};

export type UpdateShiftResponse = {
  __typename?: 'updateShiftResponse';
  dayShift?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Time']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  intensityScore?: Maybe<Scalars['Int']['output']>;
  intensitySurveyResult?: Maybe<Array<Maybe<IntensitySurveyResultItem>>>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  tiredenessSurveyResult?: Maybe<Array<Maybe<TiredenessSurveyResultItem>>>;
};

export type UpdateUserProcedureExperienceData = {
  confidenceScore?: InputMaybe<Scalars['Int']['input']>;
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateUserProcedureExperienceInput = {
  data: UpdateUserProcedureExperienceData;
  id: Scalars['UUID']['input'];
};

export type UpdateUserProcedureExperienceResponse = {
  __typename?: 'updateUserProcedureExperienceResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateInstitutionWithAdminAndDepartmentMutationVariables = Exact<{
  input: CreateInstitutionWithAdminAndDepartmentInput;
}>;


export type CreateInstitutionWithAdminAndDepartmentMutation = { __typename?: 'Mutation', createInstitutionWithAdminAndDepartmentInput: { __typename?: 'CreateInstitutionWithAdminAndDepartmentPayload', status: boolean, message?: string | null, institution?: { __typename?: 'Institution', id?: any | null, name?: string | null } | null, department?: { __typename?: 'Department', id: any, name?: string | null } | null, invite?: { __typename?: 'InviteStub', email: string, token: string, expiresAt: string } | null } };

export type GetInstitutionSubscriptionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstitutionSubscriptionInfoQuery = { __typename?: 'Query', getInstitutionSubscription?: { __typename?: 'InstitutionSubscription', id: string, institutionUuid: string, start?: string | null, end?: string | null, status?: SubscriptionStatus | null } | null };

export type SignupUserStartTrialMutationVariables = Exact<{
  input: SignupUserStartTrialInput;
}>;


export type SignupUserStartTrialMutation = { __typename?: 'Mutation', signupUserStartTrial: { __typename?: 'SignupUserStartTrialPayload', status: boolean, message?: string | null, user?: { __typename?: 'User', id?: any | null, code?: string | null, name?: string | null, email?: string | null } | null } };

export type GetProcedureQueryVariables = Exact<{
  input: GetProceduresInput;
}>;


export type GetProcedureQuery = { __typename?: 'Query', getProcedures: { __typename?: 'GetProceduresResponse', items?: Array<{ __typename?: 'Procedure', name?: string | null, id?: any | null, code?: any | null, isPublic?: boolean | null, isEnabled?: boolean | null, description?: string | null, language?: string | null, checklist?: Array<string | null> | null, createdAt?: any | null, updateAt?: any | null, steps?: Array<{ __typename?: 'ProcedureStep', id: any, title: string, type: ProcedureStepType, order?: number | null, transitionType: ProcedureStepExitType, media?: Array<{ __typename?: 'ProcedureStepMedia', id: any, type: ProcedureStepMediaType, url: string, bucket: string, bucketFilename: string, originalFilename: string, size?: number | null } | null> | null, parent?: Array<{ __typename?: 'ProcedureStepParent', stepId: any, exitId: any } | null> | null, exits?: Array<{ __typename?: 'ProcedureStepExit', id: any, valueType: ProcedureStepExitValueType, value?: string | null, valueMin?: number | null, valueMax?: number | null } | null> | null, errors?: Array<{ __typename?: 'StepError', stepName?: string | null, error?: string | null } | null> | null } | null> | null, departments?: Array<{ __typename?: 'Department', id: any, name?: string | null, institution?: { __typename?: 'Institution', name?: string | null } | null } | null> | null, category?: { __typename?: 'Category', id?: any | null, name: string } | null, author?: { __typename?: 'User', id?: any | null, name?: string | null } | null } | null> | null } };

export type GetProceduresQueryVariables = Exact<{
  input: GetProceduresInput;
}>;


export type GetProceduresQuery = { __typename?: 'Query', getProcedures: { __typename?: 'GetProceduresResponse', items?: Array<{ __typename?: 'Procedure', id?: any | null, code?: any | null, name?: string | null, isPublic?: boolean | null, isEnabled?: boolean | null, createdAt?: any | null, departments?: Array<{ __typename?: 'Department', name?: string | null } | null> | null, category?: { __typename?: 'Category', name: string } | null } | null> | null, pager?: { __typename?: 'PagerResponse', count?: number | null, offset?: number | null, limit?: number | null } | null } };

export type CurrentUserQueryVariables = Exact<{
  input?: InputMaybe<GetCurrentUserInput>;
}>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUserResponse', activeSub?: boolean | null, profile?: { __typename?: 'User', id?: any | null, name?: string | null, email?: string | null, language?: string | null, avatarUrl?: string | null } | null, roles?: Array<{ __typename?: 'UserRole', departmentId?: any | null, departmentName?: string | null, institutionId?: any | null, institutionName?: string | null, role: string, roleName?: string | null, priority?: number | null } | null> | null } };

export type GetCategoriesQueryVariables = Exact<{
  input: GetCategoriesInput;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', getCategories: { __typename?: 'GetCategoriesResponse', items?: Array<{ __typename?: 'Category', id?: any | null, name: string } | null> | null } };

export type DeleteProcedureMutationVariables = Exact<{
  input: DeleteProcedureInput;
}>;


export type DeleteProcedureMutation = { __typename?: 'Mutation', deleteProcedure: { __typename?: 'DeleteProcedureResponse', status: boolean, message?: string | null, code?: string | null } };

export type CreateProcedureMutationVariables = Exact<{
  input: CreateProcedureInput;
}>;


export type CreateProcedureMutation = { __typename?: 'Mutation', createProcedure: { __typename?: 'CreateProcedureResponse', status: boolean, procedure: { __typename?: 'Procedure', code?: any | null } } };

export type UpdateProcedureMutationVariables = Exact<{
  input: UpdateProcedureInput;
}>;


export type UpdateProcedureMutation = { __typename?: 'Mutation', updateProcedure: { __typename?: 'CreateProcedureResponse', status: boolean, procedure: { __typename?: 'Procedure', name?: string | null, id?: any | null, code?: any | null, isPublic?: boolean | null, description?: string | null, language?: string | null, checklist?: Array<string | null> | null, createdAt?: any | null, updateAt?: any | null, steps?: Array<{ __typename?: 'ProcedureStep', id: any, title: string, type: ProcedureStepType, order?: number | null, transitionType: ProcedureStepExitType, media?: Array<{ __typename?: 'ProcedureStepMedia', id: any, type: ProcedureStepMediaType, url: string, bucket: string, bucketFilename: string, originalFilename: string, size?: number | null } | null> | null, parent?: Array<{ __typename?: 'ProcedureStepParent', stepId: any, exitId: any } | null> | null, exits?: Array<{ __typename?: 'ProcedureStepExit', id: any, valueType: ProcedureStepExitValueType, value?: string | null, valueMin?: number | null, valueMax?: number | null } | null> | null, errors?: Array<{ __typename?: 'StepError', stepName?: string | null, error?: string | null } | null> | null } | null> | null, category?: { __typename?: 'Category', id?: any | null, name: string } | null, author?: { __typename?: 'User', name?: string | null } | null, departments?: Array<{ __typename?: 'Department', name?: string | null, institution?: { __typename?: 'Institution', name?: string | null } | null } | null> | null } } };

export type GetInstitutionsQueryVariables = Exact<{
  input: GetInstitutionsInput;
}>;


export type GetInstitutionsQuery = { __typename?: 'Query', getInstitutions: { __typename?: 'GetInstitutionsResponse', items?: Array<{ __typename?: 'Institution', id?: any | null, name?: string | null, street?: string | null, house?: string | null, city?: string | null, county?: string | null, country?: string | null, timezone?: string | null, language?: string | null, createdAt?: any | null, stopDetectionDuration?: number | null, administrators?: Array<{ __typename?: 'User', id?: any | null, name?: string | null } | null> | null } | null> | null, pager?: { __typename?: 'PagerResponse', count?: number | null, limit?: number | null, offset?: number | null } | null } };

export type CreateInstitutionMutationVariables = Exact<{
  input: CreateInstitutionInput;
}>;


export type CreateInstitutionMutation = { __typename?: 'Mutation', createInstitution: { __typename?: 'CreateInstitutionResponse', status?: boolean | null, institution?: { __typename?: 'Institution', name?: string | null } | null } };

export type UpdateInstitutionMutationVariables = Exact<{
  input: UpdateInstitutionInput;
}>;


export type UpdateInstitutionMutation = { __typename?: 'Mutation', updateInstitution: { __typename?: 'UpdateInstitutionResponse', status?: boolean | null, institution?: { __typename?: 'Institution', name?: string | null } | null } };

export type GetStudiesQueryVariables = Exact<{
  input: GetStudiesInput;
}>;


export type GetStudiesQuery = { __typename?: 'Query', getStudies: { __typename?: 'GetStudiesResponse', items?: Array<{ __typename?: 'Study', id: any, name: string, description?: string | null, startsAt?: any | null, endsAt?: any | null, status?: StudyStatus | null, permission?: StudyPermission | null, createdAt?: any | null, department?: { __typename?: 'Department', id: any, name?: string | null, institution?: { __typename?: 'Institution', name?: string | null } | null } | null, author?: { __typename?: 'User', name?: string | null } | null, survey?: Array<{ __typename?: 'Survey', id?: any | null, oldId?: string | null, name?: string | null, startsAt?: any | null, endsAt?: any | null, status?: SurveyStatus | null, position?: number | null, surveyType?: SurveyType | null, results?: Array<{ __typename?: 'SurveyResult', answers?: Array<any | null> | null, id: any, date?: any | null, user?: { __typename?: 'User', id?: any | null, name?: string | null } | null } | null> | null, parentSurvey?: { __typename?: 'Survey', oldId?: string | null, id?: any | null, name?: string | null } | null } | null> | null } | null> | null, pager?: { __typename?: 'PagerResponse', count?: number | null, offset?: number | null, limit?: number | null } | null } };

export type CreateStudyMutationVariables = Exact<{
  input: CreateStudyInput;
}>;


export type CreateStudyMutation = { __typename?: 'Mutation', createStudy: { __typename?: 'CreateStudyResponse', status: boolean, message?: string | null, study: { __typename?: 'Study', name: string } } };

export type UpdateStudyMutationVariables = Exact<{
  input: UpdateStudyInput;
}>;


export type UpdateStudyMutation = { __typename?: 'Mutation', updateStudy: { __typename?: 'UpdateStudyResponse', status: boolean, message?: string | null, study: { __typename?: 'Study', id: any, name: string, description?: string | null, startsAt?: any | null, endsAt?: any | null, status?: StudyStatus | null, permission?: StudyPermission | null, createdAt?: any | null, department?: { __typename?: 'Department', id: any, name?: string | null } | null, author?: { __typename?: 'User', name?: string | null } | null, survey?: Array<{ __typename?: 'Survey', id?: any | null, oldId?: string | null, name?: string | null, startsAt?: any | null, endsAt?: any | null, status?: SurveyStatus | null, position?: number | null, surveyType?: SurveyType | null, parentSurvey?: { __typename?: 'Survey', oldId?: string | null, id?: any | null, name?: string | null } | null } | null> | null } } };

export type DeleteStudyMutationVariables = Exact<{
  input: DeleteStudyInput;
}>;


export type DeleteStudyMutation = { __typename?: 'Mutation', deleteStudy: { __typename?: 'DeleteStudyResponse', status: boolean } };

export type GetSurveysQueryVariables = Exact<{
  input: GetSurveysInput;
}>;


export type GetSurveysQuery = { __typename?: 'Query', getSurveys: { __typename?: 'GetSurveysResponse', items?: Array<{ __typename?: 'Survey', id?: any | null, oldId?: string | null, surveyType?: SurveyType | null, name?: string | null, description?: string | null, startsAt?: any | null, endsAt?: any | null, status?: SurveyStatus | null, position?: number | null, overallScore?: boolean | null, study?: { __typename?: 'Study', id: any, name: string } | null, parentSurvey?: { __typename?: 'Survey', name?: string | null, id?: any | null } | null, author?: { __typename?: 'User', name?: string | null } | null, questions?: Array<{ __typename?: 'Question', id: any, name?: string | null, type: QuestionType, position?: number | null, category?: { __typename?: 'Category', id?: any | null, name: string } | null, details?:
          | { __typename?: 'ChoiceQuestion', question?: string | null, answers?: Array<{ __typename?: 'ScaleAnswer', value?: string | null } | null> | null }
          | { __typename?: 'CognitionQuestion' }
          | { __typename?: 'FreeTextQuestion' }
          | { __typename?: 'MediaQuestion' }
          | { __typename?: 'MultiChoiceQuestion', question?: string | null, answers?: Array<{ __typename?: 'ScaleAnswer', value?: string | null } | null> | null }
          | { __typename?: 'ScaleQuestion', question?: string | null, optionValues?: Array<{ __typename?: 'ScaleOptionValue', value?: number | null, meaning?: string | null } | null> | null }
         | null } | null> | null, childSurvey?: Array<{ __typename?: 'Survey', id?: any | null, oldId?: string | null, name?: string | null, surveyType?: SurveyType | null, position?: number | null } | null> | null, category?: Array<{ __typename?: 'Category', id?: any | null, name: string, description?: string | null } | null> | null } | null> | null } };

export type CreateSurveyMutationVariables = Exact<{
  input: CreateSurveyInput;
}>;


export type CreateSurveyMutation = { __typename?: 'Mutation', createSurvey: { __typename?: 'CreateSurveyResponse', status: boolean, survey: { __typename?: 'Survey', id?: any | null, oldId?: string | null, name?: string | null, startsAt?: any | null, endsAt?: any | null, surveyType?: SurveyType | null, overallScore?: boolean | null } } };

export type UpdateSurveyMutationVariables = Exact<{
  input: UpdateSurveyInput;
}>;


export type UpdateSurveyMutation = { __typename?: 'Mutation', updateSurvey: { __typename?: 'UpdateSurveyResponse', survey: { __typename?: 'Survey', id?: any | null, name?: string | null, startsAt?: any | null, endsAt?: any | null, description?: string | null, overallScore?: boolean | null } } };

export type DeleteSurveyMutationVariables = Exact<{
  input: DeleteSurveyInput;
}>;


export type DeleteSurveyMutation = { __typename?: 'Mutation', deleteSurvey: { __typename?: 'DeleteSurveyResponse', status: boolean } };

export type GetSurveyChartDataQueryVariables = Exact<{
  input: GetSurveyChartDataInput;
}>;


export type GetSurveyChartDataQuery = { __typename?: 'Query', getSurveyChartData: { __typename?: 'GetSurveyChartDataResponse', labels: Array<string>, datasets: Array<{ __typename?: 'ChartDataCategoryResult', avg: Array<number>, categoryId: string, categoryName: string, sum: Array<number> }> } };

export type CreateQuestionMutationVariables = Exact<{
  input: CreateQuestionInput;
}>;


export type CreateQuestionMutation = { __typename?: 'Mutation', createQuestion: { __typename?: 'CreateQuestionResponse', status: boolean, question?: { __typename?: 'Question', id: any, name?: string | null } | null } };

export type UpdateQuestionMutationVariables = Exact<{
  input: UpdateQuestionInput;
}>;


export type UpdateQuestionMutation = { __typename?: 'Mutation', updateQuestion?: { __typename?: 'UpdateQuestionResponse', question?: { __typename?: 'Question', id: any, name?: string | null, type: QuestionType, category?: { __typename?: 'Category', id?: any | null, name: string } | null } | null } | null };

export type DeleteQuestionMutationVariables = Exact<{
  input: DeleteQuestionInput;
}>;


export type DeleteQuestionMutation = { __typename?: 'Mutation', deleteQuestion: { __typename?: 'DeleteQuestionResponse', status: boolean } };

export type UpdateSurveyPositionMutationVariables = Exact<{
  input: UpdateSurveyPositionInput;
}>;


export type UpdateSurveyPositionMutation = { __typename?: 'Mutation', updateSurveyPosition: { __typename?: 'UpdateSurveyPositionResponse', status: boolean, survey: { __typename?: 'Survey', id?: any | null, name?: string | null, position?: number | null } } };

export type UpdateQuestionPositionMutationVariables = Exact<{
  input: UpdateQuestionPositionInput;
}>;


export type UpdateQuestionPositionMutation = { __typename?: 'Mutation', updateQuestionPosition?: { __typename?: 'UpdateQuestionPositionResponse', status: boolean, surveyQuestion: { __typename?: 'SurveyQuestion', id: any, position?: number | null } } | null };

export type CreateCategoryMutationVariables = Exact<{
  input: CreateCategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'CreateCategoryResponse', status?: boolean | null, category?: { __typename?: 'Category', id?: any | null, name: string } | null } };

export type UpdateCategoryMutationVariables = Exact<{
  input: UpdateCategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'UpdateCategoryResponse', name?: string | null, description?: string | null } };

export type DeleteCategoryMutationVariables = Exact<{
  input: DeleteCategoryInput;
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory: { __typename?: 'DeleteCategoryResponse', status?: string | null } };

export type DeleteQuestionCategoryMutationVariables = Exact<{
  input: DeleteQuestionCategoryInput;
}>;


export type DeleteQuestionCategoryMutation = { __typename?: 'Mutation', deleteQuestionCategory: { __typename?: 'DeleteQuestionCategoryResponse', status?: string | null } };

export type GetLearningObjectsQueryVariables = Exact<{
  input: GetLearningObjectsInput;
}>;


export type GetLearningObjectsQuery = { __typename?: 'Query', getLearningObjects: { __typename?: 'GetLearningObjectsResponse', items?: Array<{ __typename?: 'LearningObject', id?: any | null, name?: string | null, content?: string | null, isEnabled?: boolean | null, createdAt?: any | null, departments?: Array<{ __typename?: 'Department', id: any, name?: string | null } | null> | null, author?: { __typename?: 'User', id?: any | null, name?: string | null } | null } | null> | null, pager?: { __typename?: 'PagerResponse', count?: number | null, offset?: number | null, limit?: number | null } | null } };

export type CreateLearningObjectMutationVariables = Exact<{
  input: CreateLearningObjectInput;
}>;


export type CreateLearningObjectMutation = { __typename?: 'Mutation', createLearningObject: { __typename?: 'CreateLearningObjectResponse', status: boolean, learningObject: { __typename?: 'LearningObject', id?: any | null, name?: string | null } } };

export type UpdateLearningObjectMutationVariables = Exact<{
  input: UpdateLearningObjectInput;
}>;


export type UpdateLearningObjectMutation = { __typename?: 'Mutation', updateLearningObject: { __typename?: 'UpdateLearningObjectResponse', status: boolean, learningObject: { __typename?: 'LearningObject', id?: any | null, name?: string | null } } };

export type DeleteLearningObjectMutationVariables = Exact<{
  input: DeleteLearningObjectInput;
}>;


export type DeleteLearningObjectMutation = { __typename?: 'Mutation', deleteLearningObject: { __typename?: 'DeleteLearningObjectResponse', status: boolean } };

export type GetMostPopularProceduresQueryVariables = Exact<{
  input: GetMostPopularProceduresInput;
}>;


export type GetMostPopularProceduresQuery = { __typename?: 'Query', getMostPopularProcedures: { __typename?: 'GetMostPopularProceduresResponse', mostPopularProcedures?: Array<{ __typename?: 'ProcedureChartDescriptionType', description?: string | null, percent?: number | null, count?: number | null } | null> | null } };

export type GetInfrequentProceduresQueryVariables = Exact<{
  input: GetInfrequentProceduresInput;
}>;


export type GetInfrequentProceduresQuery = { __typename?: 'Query', getInfrequentProcedures: { __typename?: 'GetInfrequentProceduresResponse', infrequentsProcedures?: Array<{ __typename?: 'ProcedureChartDescriptionType', description?: string | null, percent?: number | null, count?: number | null } | null> | null } };

export type GetNursesExperienceQueryVariables = Exact<{
  input: GetNursesExperienceInput;
}>;


export type GetNursesExperienceQuery = { __typename?: 'Query', getNursesExperience: { __typename?: 'getNursesExperienceResponse', fromFiveToTen?: number | null, fromOneToFive?: number | null, lessThanOne?: number | null, moreThanTen?: number | null, count?: number | null } };

export type GetNurseAgeExperienceStatsQueryVariables = Exact<{
  input: GetNurseAgeExperienceStatsInput;
}>;


export type GetNurseAgeExperienceStatsQuery = { __typename?: 'Query', getNurseAgeExperienceStats: { __typename?: 'getNurseAgeExperienceStatsResponse', stats?: Array<{ __typename?: 'AgeExperienceStats', maleCount?: number | null, monthOfBirth?: string | null, femaleCount?: number | null } | null> | null } };

export type GetNurseAgeStatQueryVariables = Exact<{
  input: GetNurseAgeStatsInput;
}>;


export type GetNurseAgeStatQuery = { __typename?: 'Query', getNurseAgeStats: { __typename?: 'getNurseAgeStatsResponse', stats?: Array<{ __typename?: 'AgeStats', averageAge?: number | null, monthOfBirth?: string | null } | null> | null } };

export type GetAverageShiftDataQueryVariables = Exact<{
  input: GetAverageShiftDataInput;
}>;


export type GetAverageShiftDataQuery = { __typename?: 'Query', getAverageShiftData: { __typename?: 'GetAverageShiftDataResponse', averageShiftDuration?: number | null, averageShiftIntensity?: number | null, durationVsPreviousMonth?: number | null, intensityShiftVsPreviousWeek?: number | null } };

export type GetAveragePatientAcuityDataQueryVariables = Exact<{
  input: GetAveragePatientAcuityDataInput;
}>;


export type GetAveragePatientAcuityDataQuery = { __typename?: 'Query', getAveragePatientAcuityData: { __typename?: 'GetAveragePatientAcuityDataResponse', averageNrOfPatients?: number | null, averageNrOfPatientsVsPreviousMonth?: number | null, averageShiftAcuity?: number | null, averageShiftAcuityVsPreviousMonth?: number | null } };

export type GetDevicesQueryVariables = Exact<{
  input: GetDevicesInput;
}>;


export type GetDevicesQuery = { __typename?: 'Query', getDevices: { __typename?: 'GetDevicesResponse', pager?: { __typename?: 'PagerResponse', count?: number | null, limit?: number | null, offset?: number | null } | null, items?: Array<{ __typename?: 'Device', name: string, lifeCycleEnd?: any | null, lifeCycleStart?: any | null, updateAt?: any | null, createdAt?: any | null, nextAuditDate?: any | null, id?: any | null, udi?: string | null, department?: { __typename?: 'Department', name?: string | null, institution?: { __typename?: 'Institution', name?: string | null } | null } | null, group?: { __typename?: 'Group', name?: string | null, lifeCycleNum?: number | null, lifeCycleTime?: LifeCycleTimeEnum | null } | null, author?: { __typename?: 'User', name?: string | null } | null } | null> | null } };

export type GetDeviceQueryVariables = Exact<{
  input: GetDeviceInput;
}>;


export type GetDeviceQuery = { __typename?: 'Query', getDevice: { __typename?: 'GetDeviceResponse', device?: { __typename?: 'Device', name: string, id?: any | null, udi?: string | null, lifeCycleEnd?: any | null, lifeCycleStart?: any | null, description?: string | null, createdAt?: any | null, updateAt?: any | null, department?: { __typename?: 'Department', name?: string | null, id: any } | null, group?: { __typename?: 'Group', id?: any | null, name?: string | null, lifeCycleTime?: LifeCycleTimeEnum | null, lifeCycleNum?: number | null, procedure?: Array<{ __typename?: 'GroupProcedure', name: string, frequencyNum?: number | null, frequencyPeriod?: FrequencyPeriodEnum | null } | null> | null } | null, procedureExecution?: Array<{ __typename?: 'DeviceProcedureExecution', name?: string | null, date?: any | null, deviceUuid?: any | null, groupProcedureUuid?: any | null, id?: any | null, status?: DeviceProcedureExecutionStatusEnum | null, userUuid?: any | null } | null> | null, comment?: Array<{ __typename?: 'DeviceComment', comment?: string | null, createdDate?: any | null, deviceUuid?: any | null, id?: any | null } | null> | null } | null } };

export type GetGroupsQueryVariables = Exact<{
  input: GetGroupsInput;
}>;


export type GetGroupsQuery = { __typename?: 'Query', getGroups: { __typename?: 'GetGroupsResponse', items?: Array<{ __typename?: 'Group', id?: any | null, lifeCycleNum?: number | null, lifeCycleTime?: LifeCycleTimeEnum | null, name?: string | null, description?: string | null, auditFrequency?: number | null, numberOfDevices?: number | null, lifeCycleEndingSoon?: number | null, department?: { __typename?: 'Department', id: any, name?: string | null } | null } | null> | null } };

export type GetGroupQueryVariables = Exact<{
  input: GetGroupInput;
}>;


export type GetGroupQuery = { __typename?: 'Query', getGroup?: { __typename?: 'Group', id?: any | null, lifeCycleNum?: number | null, lifeCycleTime?: LifeCycleTimeEnum | null, name?: string | null, description?: string | null, auditFrequency?: number | null, numberOfDevices?: number | null, lifeCycleEndingSoon?: number | null, image?: string | null, department?: { __typename?: 'Department', id: any, name?: string | null } | null, auditProcedure?: { __typename?: 'GroupProcedure', id?: any | null, name: string, frequencyNum?: number | null, frequencyPeriod?: FrequencyPeriodEnum | null } | null, procedure?: Array<{ __typename?: 'GroupProcedure', isAudit?: boolean | null, name: string, id?: any | null, frequencyPeriod?: FrequencyPeriodEnum | null, frequencyNum?: number | null, groupProcedureUuid?: any | null } | null> | null, learningObject?: Array<{ __typename?: 'LearningObject', name?: string | null, content?: string | null, id?: any | null } | null> | null } | null };

export type CreateDevicesMutationVariables = Exact<{
  input: Array<CreateDeviceInput> | CreateDeviceInput;
}>;


export type CreateDevicesMutation = { __typename?: 'Mutation', createDevices: Array<{ __typename?: 'CreateDeviceResponse', message?: string | null }> };

export type UpdateDeviceMutationVariables = Exact<{
  input: UpdateDeviceInput;
}>;


export type UpdateDeviceMutation = { __typename?: 'Mutation', updateDevice: { __typename?: 'CreateDeviceResponse', message?: string | null, status: boolean } };

export type GetDeviceReportTotalQueryVariables = Exact<{
  input: GetDeviceReportTotalInput;
}>;


export type GetDeviceReportTotalQuery = { __typename?: 'Query', getDeviceReportTotal: { __typename?: 'GetDeviceReportTotalResponse', items?: Array<{ __typename?: 'DeviceReportTotalItem', numberOfProcedures?: { __typename?: 'numberOfProceduresType', numberOfExecutedProcedures?: number | null, numberOfFailedAudits?: number | null, numberOfFinishedProcedures?: number | null, numberOfStoppedProcedures?: number | null, numberOfSuccessfullAudits?: number | null } | null, group?: { __typename?: 'Group', name?: string | null, id?: any | null, department?: { __typename?: 'Department', name?: string | null, id: any } | null } | null } | null> | null, totalRecords?: { __typename?: 'TotalRecordsType', totalNumberOfExecutedProcedures?: number | null, totalNumberOfFailedAudits?: number | null, totalNumberOfFinishedProcedures?: number | null, totalNumberOfSuccessfullAudits?: number | null, totalNumberOfStoppedProcedures?: number | null } | null } };

export type GetDeviceReportQueryVariables = Exact<{
  input: GetDeviceReportInput;
}>;


export type GetDeviceReportQuery = { __typename?: 'Query', getDeviceReport: { __typename?: 'GetDeviceReportResponse', records?: { __typename?: 'numberOfProceduresType', numberOfSuccessfullAudits?: number | null, numberOfStoppedProcedures?: number | null, numberOfFinishedProcedures?: number | null, numberOfFailedAudits?: number | null, numberOfExecutedProcedures?: number | null } | null, items?: Array<{ __typename?: 'GetDeviceReportData', deviceProcedureExecution?: { __typename?: 'DeviceProcedureExecution', name?: string | null, id?: any | null, userUuid?: any | null, date?: any | null, status?: DeviceProcedureExecutionStatusEnum | null } | null, procedure?: { __typename?: 'Procedure', name?: string | null, id?: any | null } | null, device?: { __typename?: 'Device', id?: any | null, name: string } | null } | null> | null } };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'CreateGroupResponse', status?: string | null } };

export type GetDeviceChartsQueryVariables = Exact<{
  input?: InputMaybe<GetDeviceChartsInput>;
}>;


export type GetDeviceChartsQuery = { __typename?: 'Query', getDeviceCharts: { __typename?: 'GetDeviceChartsResponse', amountAuditNormal?: number | null, amountAuditPast?: number | null, amountAuditSoon?: number | null, amountEnded?: number | null, amountEnding?: number | null, amountNormal?: number | null } };

export type GetRateOfFailedAuditsQueryVariables = Exact<{
  input?: InputMaybe<GetRateOfFailedAuditsInput>;
}>;


export type GetRateOfFailedAuditsQuery = { __typename?: 'Query', getRateOfFailedAudits?: Array<{ __typename?: 'GetRateOfFailedAuditsResponse', failedAudits?: number | null, id?: any | null, name?: string | null } | null> | null };

export type GetNumberOfExecutedProceduresQueryVariables = Exact<{
  input: GetNumberOfExecutedProceduresInput;
}>;


export type GetNumberOfExecutedProceduresQuery = { __typename?: 'Query', getNumberOfExecutedProcedures: { __typename?: 'GetNumberOfExecutedProceduresResponse', dates?: Array<any | null> | null, data?: Array<{ __typename?: 'NumberOfExecutedProceduresResponseData', procedureId?: any | null, name?: string | null, dataset?: Array<number | null> | null } | null> | null } };

export type GetAverageTimeSpentOnProcedureQueryVariables = Exact<{
  input: GetAverageTimeSpentOnProcedureInput;
}>;


export type GetAverageTimeSpentOnProcedureQuery = { __typename?: 'Query', getAverageTimeSpentOnProcedure: { __typename?: 'GetAverageTimeSpentOnProcedureResponse', dates?: Array<any | null> | null, data?: Array<{ __typename?: 'AverageTimeSpentOnProcedureResponseData', dataset?: Array<number | null> | null, name?: string | null, procedureId?: any | null } | null> | null } };

export type GetAverageNurseAgeChartQueryVariables = Exact<{
  input: GetAverageNurseAgeChartInput;
}>;


export type GetAverageNurseAgeChartQuery = { __typename?: 'Query', getAverageNurseAgeChart: { __typename?: 'GetAverageNurseAgeChartResponse', data?: Array<number | null> | null, dates?: Array<any | null> | null } };

export type GetNursesGenderChartQueryVariables = Exact<{
  input: GetNursesGenderChartInput;
}>;


export type GetNursesGenderChartQuery = { __typename?: 'Query', getNursesGenderChart: { __typename?: 'GetNursesGenderChartResponse', dates?: Array<any | null> | null, females?: Array<number | null> | null, males?: Array<number | null> | null } };

export type GetFiveMostFrequentlyProceduresQueryVariables = Exact<{
  input: GetFiveMostFrequentlyProceduresInput;
}>;


export type GetFiveMostFrequentlyProceduresQuery = { __typename?: 'Query', getFiveMostFrequentlyProcedures?: Array<{ __typename?: 'ProcedureChart', numberOfExecutions?: number | null, procedure?: { __typename?: 'Procedure', id?: any | null, name?: string | null, description?: string | null } | null } | null> | null };

export type GetFiveLeastFrequentlyProceduresQueryVariables = Exact<{
  input: GetFiveLeastFrequentlyProceduresInput;
}>;


export type GetFiveLeastFrequentlyProceduresQuery = { __typename?: 'Query', getFiveLeastFrequentlyProcedures?: Array<{ __typename?: 'ProcedureChart', numberOfExecutions?: number | null, procedure?: { __typename?: 'Procedure', id?: any | null, name?: string | null, description?: string | null } | null } | null> | null };

export type GetFiveMostAssistedProceduresQueryVariables = Exact<{
  input: GetFiveMostAssistedProceduresInput;
}>;


export type GetFiveMostAssistedProceduresQuery = { __typename?: 'Query', getFiveMostAssistedProcedures?: Array<{ __typename?: 'MostAssistedProceduresChart', numberOfSuggestedAssistances?: number | null, procedure?: { __typename?: 'Procedure', id?: any | null, name?: string | null, description?: string | null } | null } | null> | null };

export type GetSurveyResultsQueryVariables = Exact<{
  input: GetSurveyResultInput;
}>;


export type GetSurveyResultsQuery = { __typename?: 'Query', getSurveyResults: { __typename?: 'GetSurveyResultResponse', items?: Array<{ __typename?: 'SurveyResult', answers?: Array<any | null> | null, id: any } | null> | null } };

export type GetShiftTirednessChartQueryVariables = Exact<{
  input: GetShiftTirednessChartInput;
}>;


export type GetShiftTirednessChartQuery = { __typename?: 'Query', getShiftTirednessChart: { __typename?: 'GetShiftTirednessChartResponse', label?: string | null, data: Array<{ __typename?: 'KeyValue', key: string, value: number }> } };

export type GetShiftIntensityChartQueryVariables = Exact<{
  input: GetShiftIntensityChartInput;
}>;


export type GetShiftIntensityChartQuery = { __typename?: 'Query', getShiftIntensityChart: { __typename?: 'GetShiftIntensityChartResponse', label?: string | null, data: Array<{ __typename?: 'KeyValue', key: string, value: number }> } };

export type GetShiftTiredenessQuestionsQueryVariables = Exact<{
  input: GetShiftTiredenessQuestionsInput;
}>;


export type GetShiftTiredenessQuestionsQuery = { __typename?: 'Query', getShiftTiredenessQuestions: { __typename?: 'GetShiftTiredenessQuestionsResponse', items?: Array<{ __typename?: 'ShiftTiredenessQuestion', name?: string | null, id?: any | null, position?: number | null } | null> | null } };

export type GetShiftIntensityQuestionsQueryVariables = Exact<{
  input: GetShiftIntensityQuestionsInput;
}>;


export type GetShiftIntensityQuestionsQuery = { __typename?: 'Query', getShiftIntensityQuestions: { __typename?: 'GetShiftIntensityQuestionsResponse', items?: Array<{ __typename?: 'ShiftIntensityQuestion', name?: string | null, id?: any | null, position?: number | null } | null> | null } };

export type GetPatientsQueryVariables = Exact<{
  input: GetPatientsInput;
}>;


export type GetPatientsQuery = { __typename?: 'Query', getPatients: { __typename?: 'GetPatientsResponse', items?: Array<{ __typename?: 'Patient', nurseUuid?: any | null, patientUuid?: any | null, departmentName?: string | null, id?: any | null, name?: string | null, createdAt?: any | null, status?: string | null, nextVisit?: { __typename?: 'PatientVisit', start?: any | null } | null, visitHistory?: Array<{ __typename?: 'PatientVisit', start?: any | null, end?: any | null, name?: string | null } | null> | null } | null> | null, pager?: { __typename?: 'PagerResponse', count?: number | null, offset?: number | null, limit?: number | null } | null } };

export type GetPatientQueryVariables = Exact<{
  input: GetPatientInput;
}>;


export type GetPatientQuery = { __typename?: 'Query', getPatient?: { __typename?: 'Patient', name?: string | null, id?: any | null, patientUuid?: any | null, location?: string | null, street?: string | null, house?: string | null, address?: string | null, departmentUuid?: any | null, departmentName?: string | null, city?: string | null, county?: string | null, country?: string | null, primaryDiagnosis?: string | null, secondaryDiagnosis?: string | null, phoneNumber?: string | null, email?: string | null, gender?: PatientGender | null, dateOfBirth?: any | null, nurseUuid?: any | null, allergy?: Array<{ __typename?: 'AllergyType', allergy?: string | null, allergyType?: string | null, reaction?: string | null, severity?: string | null } | null> | null, user?: Array<{ __typename?: 'User', name?: string | null } | null> | null, visitHistory?: Array<{ __typename?: 'PatientVisit', id?: any | null, userUuid?: any | null, patientUuid?: any | null, name?: string | null, start?: any | null, end?: any | null, status?: VisitStatusEnum | null, user?: { __typename?: 'User', name?: string | null } | null } | null> | null, medication?: Array<{ __typename?: 'MedicationType', medication?: string | null, medicationType?: string | null, dosage?: string | null, frequency?: string | null, startDate?: any | null, duration?: string | null, note?: string | null } | null> | null, assignedProcedure?: Array<{ __typename?: 'ProcedureExecutionItemType', id?: any | null, procedureUuid?: any | null, name?: string | null, startAt?: any | null, endAt?: any | null, userUuid?: any | null, category?: { __typename?: 'Category', id?: any | null, name: string } | null } | null> | null, scheduledProcedure?: Array<{ __typename?: 'ProcedureExecutionItemType', id?: any | null, procedureUuid?: any | null, name?: string | null, startAt?: any | null, endAt?: any | null, userUuid?: any | null, note?: string | null, category?: { __typename?: 'Category', id?: any | null, name: string } | null } | null> | null, missedProcedure?: Array<{ __typename?: 'ProcedureExecutionItemType', id?: any | null, procedureUuid?: any | null, name?: string | null, startAt?: any | null, endAt?: any | null, userUuid?: any | null, note?: string | null, category?: { __typename?: 'Category', id?: any | null, name: string } | null } | null> | null, procedure?: Array<{ __typename?: 'ProcedureExecutionItemType', name?: string | null } | null> | null } | null };

export type AddPatientMutationVariables = Exact<{
  input: AddPatientInput;
}>;


export type AddPatientMutation = { __typename?: 'Mutation', addPatient: { __typename?: 'AddPatientResponse', id?: any | null, name?: string | null } };

export type UpdatePatientMutationVariables = Exact<{
  input: UpdatePatientInput;
}>;


export type UpdatePatientMutation = { __typename?: 'Mutation', updatePatient: { __typename?: 'UpdatePatientResponse', id?: any | null } };

export type UpdateProcedureExecutionMutationVariables = Exact<{
  input: UpdateProcedureExecutionInput;
}>;


export type UpdateProcedureExecutionMutation = { __typename?: 'Mutation', updateProcedureExecution: { __typename?: 'updateProcedureExecutionResponse', id?: any | null } };

export type CreateProcedureExecutionMutationVariables = Exact<{
  input: CreateProcedureExecutionInput;
}>;


export type CreateProcedureExecutionMutation = { __typename?: 'Mutation', createProcedureExecution: { __typename?: 'createProcedureExecutionResponse', startAt?: any | null, endAt?: any | null, id?: any | null, note?: string | null, procedureUuid?: any | null, patientUuid?: any | null, userUuid?: any | null, name?: string | null } };

export type AddPatientVisitMutationVariables = Exact<{
  input: AddPatientVisitInput;
}>;


export type AddPatientVisitMutation = { __typename?: 'Mutation', addPatientVisit: { __typename?: 'AddPatientVisitResponse', id?: any | null, userUuid?: any | null, name?: string | null, start?: any | null, end?: any | null, status?: VisitStatusEnum | null } };

export type GetConsentQueryVariables = Exact<{
  patientId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetConsentQuery = { __typename?: 'Query', getConsent?: { __typename?: 'ConsentResponse', patientUuid?: any | null, signer?: Signer | null, name?: string | null, surname?: string | null, date?: any | null } | null };

export type DeletePatientVisitMutationVariables = Exact<{
  input: DeletePatientVisitInput;
}>;


export type DeletePatientVisitMutation = { __typename?: 'Mutation', deletePatientVisit: { __typename?: 'DeletePatientVisitResponse', status?: string | null } };

export type UpdatePatientVisitMutationVariables = Exact<{
  input: UpdatePatientVisitInput;
}>;


export type UpdatePatientVisitMutation = { __typename?: 'Mutation', updatePatientVisit: { __typename?: 'UpdatePatientVisitResponse', id?: any | null } };

export type DeleteProcedureExecutionMutationVariables = Exact<{
  input: DeleteProcedureExecutionInput;
}>;


export type DeleteProcedureExecutionMutation = { __typename?: 'Mutation', deleteProcedureExecution: { __typename?: 'deleteProcedureExecutionResponse', status?: string | null } };

export type GetShiftsWithVisitsQueryVariables = Exact<{
  input: GetShiftsWithVisitsInput;
}>;


export type GetShiftsWithVisitsQuery = { __typename?: 'Query', getShiftsWithVisits: { __typename?: 'getShiftsWithVisitsResponse', items?: Array<{ __typename?: 'ShiftWithVisits', id: any, startTime?: any | null, endTime?: any | null, visits?: Array<{ __typename?: 'PatientVisit', start?: any | null, status?: VisitStatusEnum | null, userUuid?: any | null, end?: any | null, id?: any | null, patient?: { __typename?: 'Patient', patientUuid?: any | null, name?: string | null } | null, checklist?: { __typename?: 'VisitChecklist', visit_uuid?: any | null } | null, user?: { __typename?: 'User', name?: string | null } | null } | null> | null } | null> | null, pager?: { __typename?: 'PagerResponse', count?: number | null, offset?: number | null, limit?: number | null } | null } };

export type GetVisitChecklistByVisitIdQueryVariables = Exact<{
  visitUuid: Scalars['UUID']['input'];
}>;


export type GetVisitChecklistByVisitIdQuery = { __typename?: 'Query', getVisitChecklistByVisitId?: Array<{ __typename?: 'VisitChecklist', instrumental_tests?: string | null, laboratory_tests?: string | null, applied_medicinal_treatment?: string | null, specialist?: string | null, anamnesis?: string | null, condition_assessment?: string | null, blood_pressure_systolic?: number | null, blood_pressure_diastolic?: number | null, consultation_plans?: string | null, complaint_data?: string | null, diagnoses?: string | null, applied_treatment?: string | null, recommendations?: string | null, patient_status: string, pulse?: number | null, weight?: number | null, height?: number | null }> | null };

export type GetShiftsQueryVariables = Exact<{
  input: GetShiftsInput;
}>;


export type GetShiftsQuery = { __typename?: 'Query', getShifts: { __typename?: 'getShiftsResponse', items?: Array<{ __typename?: 'Shift', id: any, userUuid: any, status?: string | null } | null> | null } };

export type GetNursesInfoCombinedQueryVariables = Exact<{
  input?: InputMaybe<NursesInfoCombinedInput>;
}>;


export type GetNursesInfoCombinedQuery = { __typename?: 'Query', getNursesInfoCombined?: Array<{ __typename?: 'NursesInfoCombinedResponse', user_uuid?: any | null, name?: any | null, departmentName?: string | null, institutionName?: string | null, arrivals?: Array<{ __typename?: 'NurseArrivalsResponse', patient_name?: string | null, location?: string | null, uuid?: any | null, time_arrive?: any | null, time_leave?: any | null, address?: string | null } | null> | null, locations?: Array<{ __typename?: 'NurseLocationsResponse', location?: string | null, time?: any | null, uuid?: any | null } | null> | null } | null> | null };

export type GetNurseRouteQueryVariables = Exact<{
  input: NurseRouteInput;
}>;


export type GetNurseRouteQuery = { __typename?: 'Query', getNurseRoute?: { __typename?: 'NurseRouteResponse', timezone: string, points: Array<{ __typename?: 'NurseRoutePoint', lat: number, lng: number, time: any }>, stops: Array<{ __typename?: 'NurseRouteStop', lat: number, lng: number, startTime: any, endTime: any, durationMinutes: number, address: string }> } | null };

export type GetRouteMapConfigQueryVariables = Exact<{
  institutionUuid: Scalars['UUID']['input'];
}>;


export type GetRouteMapConfigQuery = { __typename?: 'Query', getRouteMapConfig?: { __typename?: 'RouteMapConfigResponse', retentionMonths: number, historyAvailableFrom: any, timezone: string } | null };

export type GetVisitsByTimePeriodQueryVariables = Exact<{
  input?: InputMaybe<GetVisitsByTimePeriodInput>;
}>;


export type GetVisitsByTimePeriodQuery = { __typename?: 'Query', getVisitsByTimePeriodPaginated?: { __typename?: 'GetVisitsByTimePeriodResponse', items?: Array<{ __typename?: 'PatientVisit', id?: any | null, userUuid?: any | null, patientUuid?: any | null, name?: string | null, start?: any | null, end?: any | null, checklist?: { __typename?: 'VisitChecklist', uuid?: any | null, visit_uuid?: any | null } | null, patient?: { __typename?: 'Patient', name?: string | null, patientUuid?: any | null } | null } | null> | null, pager?: { __typename?: 'PagerResponse', count?: number | null, offset?: number | null, limit?: number | null } | null } | null };

export type ProcedureStepDetailsFragment = { __typename?: 'ProcedureStep', id: any, title: string, type: ProcedureStepType, order?: number | null, transitionType: ProcedureStepExitType, media?: Array<{ __typename?: 'ProcedureStepMedia', id: any, type: ProcedureStepMediaType, url: string, bucket: string, bucketFilename: string, originalFilename: string, size?: number | null } | null> | null, parent?: Array<{ __typename?: 'ProcedureStepParent', stepId: any, exitId: any } | null> | null, exits?: Array<{ __typename?: 'ProcedureStepExit', id: any, valueType: ProcedureStepExitValueType, value?: string | null, valueMin?: number | null, valueMax?: number | null } | null> | null, errors?: Array<{ __typename?: 'StepError', stepName?: string | null, error?: string | null } | null> | null };

export type GetApprovalRequestsQueryVariables = Exact<{
  input?: InputMaybe<ApprovalRequestsInput>;
}>;


export type GetApprovalRequestsQuery = { __typename?: 'Query', approvalRequests: { __typename?: 'ApprovalRequestsResponse', items: Array<{ __typename?: 'ApprovalRequest', id: string, actionType: ApprovalActionType, status: ApprovalStatus, rejectionReason?: string | null, payload: any, expiresAt: any, usedAt?: any | null, createdAt: any, requestedBy: { __typename?: 'User', id?: any | null, name?: string | null, email?: string | null }, approvedBy?: { __typename?: 'User', id?: any | null, name?: string | null, email?: string | null } | null, rejectedBy?: { __typename?: 'User', id?: any | null, name?: string | null, email?: string | null } | null }>, pager?: { __typename?: 'PagerResponse', count?: number | null, offset?: number | null, limit?: number | null } | null } };

export type GetApprovalRequestsCountQueryVariables = Exact<{
  input?: InputMaybe<ApprovalRequestsInput>;
}>;


export type GetApprovalRequestsCountQuery = { __typename?: 'Query', approvalRequests: { __typename?: 'ApprovalRequestsResponse', pager?: { __typename?: 'PagerResponse', count?: number | null } | null } };

export type ApproveActionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApproveActionMutation = { __typename?: 'Mutation', approveAction: { __typename?: 'ApprovalRequest', id: string, status: ApprovalStatus } };

export type RejectActionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectActionMutation = { __typename?: 'Mutation', rejectAction: { __typename?: 'ApprovalRequest', id: string, status: ApprovalStatus } };

export type GetDepartmentsQueryVariables = Exact<{
  input: GetDepartmentsInput;
}>;


export type GetDepartmentsQuery = { __typename?: 'Query', getDepartments: { __typename?: 'GetDepartmentsResponse', items?: Array<{ __typename?: 'Department', id: any, name?: string | null, createdAt?: any | null, institution?: { __typename?: 'Institution', id?: any | null, name?: string | null } | null, users?: Array<{ __typename?: 'User', name?: string | null, roles?: Array<{ __typename?: 'UserRole', departmentId?: any | null, role: string } | null> | null } | null> | null } | null> | null, pager?: { __typename?: 'PagerResponse', limit?: number | null, offset?: number | null, count?: number | null } | null } };

export type CreateDepartmentMutationVariables = Exact<{
  input: CreateDepartmentInput;
}>;


export type CreateDepartmentMutation = { __typename?: 'Mutation', createDepartment: { __typename?: 'CreateDepartmentResponse', status: boolean, department: { __typename?: 'Department', name?: string | null } } };

export type UpdateDepartmentMutationVariables = Exact<{
  input: UpdateDepartmentInput;
}>;


export type UpdateDepartmentMutation = { __typename?: 'Mutation', updateDepartment: { __typename?: 'UpdateDepartmentResponse', status: boolean, department: { __typename?: 'Department', name?: string | null } } };

export type GetRolesQueryVariables = Exact<{
  input: GetRolesInput;
}>;


export type GetRolesQuery = { __typename?: 'Query', getRoles: { __typename?: 'GetRolesResponse', items?: Array<{ __typename?: 'Role', id: any, name?: string | null, type?: string | null } | null> | null, pager?: { __typename?: 'PagerResponse', count?: number | null, limit?: number | null, offset?: number | null } | null } };

export type GetStripePricesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripePricesQuery = { __typename?: 'Query', stripePrices: Array<{ __typename?: 'StripePrice', id: string, lookup_key?: string | null, nickname?: string | null, currency?: string | null, unit_amount?: number | null, tiers_mode?: string | null, tiers?: Array<{ __typename?: 'StripeTier', up_to?: number | null, unit_amount?: number | null, flat_amount?: number | null } | null> | null, recurring?: { __typename?: 'StripeRecurring', interval?: string | null, interval_count?: number | null } | null, product?: { __typename?: 'StripeProduct', id: string, name?: string | null, description?: string | null, active?: boolean | null } | null }> };

export type CreateBillingPortalSessionMutationVariables = Exact<{
  input: CreateBillingPortalInput;
}>;


export type CreateBillingPortalSessionMutation = { __typename?: 'Mutation', createBillingPortalSession: { __typename?: 'CreateBillingPortalPayload', url: string } };

export type GetInstitutionSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstitutionSubscriptionQuery = { __typename?: 'Query', getInstitutionSubscription?: { __typename?: 'InstitutionSubscription', id: string, institutionUuid: string, start?: string | null, end?: string | null, status?: SubscriptionStatus | null, stripeCustomerUuid?: string | null, cancellationReason?: string | null, admin?: boolean | null, stripePlan?: { __typename?: 'StripePlan', priceId?: string | null, nickname?: string | null, productName?: string | null, amount?: number | null, currency?: string | null, interval?: string | null } | null } | null };

export type CreateCheckoutSessionMutationVariables = Exact<{
  input: CreateCheckoutInput;
}>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession?: { __typename?: 'CheckoutSession', url: string } | null };

export type DeleteUsersMutationVariables = Exact<{
  input: DeleteUsersInput;
}>;


export type DeleteUsersMutation = { __typename?: 'Mutation', deleteUsers: { __typename?: 'DeleteUsersResponse', status: string } };

export type DisableUsersMutationVariables = Exact<{
  input: DisableUsersInput;
}>;


export type DisableUsersMutation = { __typename?: 'Mutation', disableUsers: { __typename?: 'DisableUsersResponse', status: string, approvalRequest?: { __typename?: 'ApprovalRequest', id: string, status: ApprovalStatus } | null } };

export type EnableUsersMutationVariables = Exact<{
  input: EnableUsersInput;
}>;


export type EnableUsersMutation = { __typename?: 'Mutation', enableUsers: { __typename?: 'EnableUsersResponse', status: string, approvalRequest?: { __typename?: 'ApprovalRequest', id: string, status: ApprovalStatus } | null } };

export type GetUsersListQueryVariables = Exact<{
  input: GetUsersInput;
}>;


export type GetUsersListQuery = { __typename?: 'Query', getUsers: { __typename?: 'GetUsersResponse', activeCount?: number | null, items?: Array<{ __typename?: 'User', id?: any | null, active?: boolean | null, disabledSubByAdmin?: boolean | null, name?: string | null, email?: string | null, passwordResetInit?: any | null, createdAt?: any | null, departments?: Array<{ __typename?: 'Department', name?: string | null } | null> | null, roles?: Array<{ __typename?: 'UserRole', userRoleId?: any | null, roleName?: string | null, departmentName?: string | null, institutionName?: string | null } | null> | null, institution?: { __typename?: 'Institution', name?: string | null } | null } | null> | null, pager?: { __typename?: 'PagerResponse', count?: number | null, offset?: number | null, limit?: number | null } | null } };

export type GetUserQueryVariables = Exact<{
  input: GetUsersInput;
}>;


export type GetUserQuery = { __typename?: 'Query', getUsers: { __typename?: 'GetUsersResponse', items?: Array<{ __typename?: 'User', id?: any | null, name?: string | null, dateOfBirth?: any | null, gender?: Gender | null, email?: string | null, avatarUrl?: string | null, institution?: { __typename?: 'Institution', name?: string | null } | null, departments?: Array<{ __typename?: 'Department', name?: string | null } | null> | null } | null> | null } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserResponse', user: { __typename?: 'User', id?: any | null, name?: string | null, dateOfBirth?: any | null, gender?: Gender | null, email?: string | null, avatarUrl?: string | null, institution?: { __typename?: 'Institution', name?: string | null } | null, departments?: Array<{ __typename?: 'Department', name?: string | null } | null> | null } } };

export type ResetUserPasswordMutationVariables = Exact<{
  input: ResetUserPasswordInput;
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', resetUserPassword: { __typename?: 'ResetUserPasswordResponse', status?: boolean | null } };

export type InviteUsersMutationVariables = Exact<{
  input: InviteUserInput;
}>;


export type InviteUsersMutation = { __typename?: 'Mutation', inviteUser: { __typename?: 'InviteUserResponse', status: boolean, message?: string | null } };

export type ReInviteUserMutationVariables = Exact<{
  input: ReInviteUserInput;
}>;


export type ReInviteUserMutation = { __typename?: 'Mutation', reInviteUser: { __typename?: 'ReInviteUserResponse', status: boolean, message?: string | null } };

export type SignupUserMutationVariables = Exact<{
  input: SignupUserInput;
}>;


export type SignupUserMutation = { __typename?: 'Mutation', signupUser: { __typename?: 'SignupUserResponse', profile?: { __typename?: 'User', id?: any | null, name?: string | null } | null } };

export type GrantUserRoleMutationVariables = Exact<{
  input: GrantUserRoleInput;
}>;


export type GrantUserRoleMutation = { __typename?: 'Mutation', grantUserRole: { __typename?: 'GrantUserRoleResponse', role?: { __typename?: 'UserDepartmentRole', id: any, roleName?: { __typename?: 'Role', name?: string | null } | null } | null, approvalRequest?: { __typename?: 'ApprovalRequest', id: string, status: ApprovalStatus } | null } };

export type RevokeUserRoleMutationVariables = Exact<{
  input: RevokeUserRoleInput;
}>;


export type RevokeUserRoleMutation = { __typename?: 'Mutation', revokeUserRole: { __typename?: 'RevokeUserRoleResponse', status?: string | null, approvalRequest?: { __typename?: 'ApprovalRequest', id: string, status: ApprovalStatus } | null } };
